import { Component, React, createRef } from "react";
import { connect } from "react-redux";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import axios from "axios";
import {
  getAgentSignup,
  regenerateAgentLink,
  cancelAgentLink,
  getSmtpSettings,
  addSmtpSettings,
  verifySmtpSettings,
  wholesaleSetupConfig,
  VerifyWholeSaleConfig,
  SubmitwholesaleConfig,
  getIntegration,
  getQuickBookAuth,
  getCallBackData,
  deleteQuickBookIntegration,
  manageVocieAlertConnection,
  deleteVoiceAlertsIntegration,
  manageMetabaseConnection,
  deleteMetabaseIntegration,
  SubmitMetadataConfig,
  SubmitChatGptdataConfig,
  sendRequestIntegration,
  manageSubpoenaIntegration,
  manageZapierIntegration,
  managePrivateIntegration,
  manageChatgptIntegration,
  manageConversationalIntegration,
  manageTwilioIntegration,
  manageFcc499Integration,
  fcc_499_integration_config,
  voicealerts_integration_config,
  saveOutboundSBCCredentials,
  saveOutboundSBCSettings,
  getOutboundSBCIntegration,
  revokeOutboundSBCIntegration,
  authenticateOutboundSBC,
  getStripeStatus,
} from "./../../../config/reseller_api_calls";
import StripeModal from "./StripeModal";
import NotificationToast from "../../../components/Notification/NotificationToast";
import { resellerLeftMenu } from "./../../../config/api_calls";
import HelperClass from "./../../../config/helperClass";
import { addSettings, addMsaInfo, setLeftMenu, setStripeStatus } from "../../../actions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { Fileupload } from "../../../components/Image/Fileupload";
import Tooltip from "@material-ui/core/Tooltip";
import MutextField from "@material-ui/core/TextField";
import PageTitle from "../ExtraComponents/PageTitle";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import CryptoJS from "crypto-js";

const auth = new HelperClass();

class Integrations extends Component {
  constructor() {
    super();
    this.state = {
      stripeStatus: null,
      stripeToastMsg: "",
      stripeToastType: "success",
      tableData: [],
      errorMessage: "",
      agentId: "",
      successMessage: "",
      SmtpErrorMessage: "",
      SmtpSuccessMessage: "",
      smtp_reg_button: false,
      smtp_test_button: false,
      waitMessage: "",
      tableLoader: true,
      signup_link: "",
      copied: false,
      copied2: false,
      cpied_value: "",
      current_id: "",
      reg_button: false,
      reg_button_login: false,
      cancel_button: false,
      tableLoader: true,
      login_url: "",
      logo: "",
      signature_image: "",
      smtp_host: "",
      smtp_user: "",
      smtp_password: "",
      smtp_method: "tls",
      smtp_port: "",
      errorHostName: "",
      errorUser: "",
      errorPassword: "",
      from_email: "",
      errorFromEmail: "",
      is_working: "",
      integration_type: "",
      wholesale_data: [],
      wholesale_title: "",
      wholesale_url: "",
      wholesale_key: "",
      wholesale_auth: "",
      wholesale_active: 0,
      wholesale_is_verified: 0,
      IntErrorMessage: "",
      IntSuccessMessage: "",
      integration_type_title: "",
      integrations: [],
      dataLoaded: true,
      dataFetched: false,
      getQuickBookAuthData: "",
      getcallbackData: "",
      errorQuickBooks: "",
      successQuickBooks: "",
      integration_id: "",
      name: "",
      email: "",
      comment: "",
      integration_type_list: [],
      searchTerm: "",
      selectedCategory: "all",
      availableCategories: [],
      isDropdownOpen: false,
      isDropdownOpenVisibility: false,
      super_admin_email: "",
      integration_action: "",
      successMessageSubpoena: "",
      errorMessageSubpoena: "",
      successMessageZapier: "",
      errorMessageZapier: "",
      successMessagePrivate: "",
      errorMessagePrivate: "",
      successMessageChatgpt: "",
      errorMessageChatgpt: "",
      successMessageConversational: "",
      errorMessageConversational: "",
      successMessageTwilio: "",
      errorMessageTwilio: "",
      successMessageFcc499: "",
      errorMessageFcc499: "",
      loading_button_fcc499: false,
      enable_on_registration: 1,
      is_enabled_on_registration: 1,
      fcc499_edit_integration_id: "",
      errorMessageFcc499Edit: "",
      successMessageFcc499Edit: "",
      loading_button_fcc499_edit: false,
      selectedVisibility: "all",
      showInfoModal: false,
      selectedIntegration: null,
      passwordShownChatGpt: false,
      askVerify: false,
      loginPassword: "",
      loginPasswordError: "",
      verifyingPassword: false,
      showVerifyPassword: false,
      voicealerts_edit_integration_id: "",
      errorMessageVoiceAlertsEdit: "",
      successMessageVoiceAlertsEdit: "",
      loading_button_voicealerts_edit: false,
      enable_fcc_499: 0,
      enable_on_registration: 0,
      errorMessageVoiceAlerts: "",
      successMessageVoiceAlerts: "",
      is_processing_voicealerts: false,
      loading_button_voicealerts: false,

      // SIPNav Integration
      sipnav_connected: false,
      sipnav_step1_saved: false,
      sipnav_api_url_saved: "",
      sipnav_username_saved: "",
      sipnav_loading: false,
      sipnav_step1_error: "",
      sipnav_step1_success: "",
      sipnav_step2_error: "",
      sipnav_step2_success: "",
      sipnav_documentation_url: "",
      sipnav_api_url: "",
      sipnav_username: "",
      sipnav_password: "",
      sipnav_show_password: false,
      sipnav_cps_limit: "10",
      sipnav_session_limit: "100",
      sipnav_no_call_progress: "12",
      sipnav_ring_time: "30",
      sipnav_enforce_cid_block: true,
      sipnav_cid_block_min_asr: "10",
      sipnav_cid_block_min_acd: "15",
      sipnav_cid_block_max_sdp: "30",
      sipnav_international_calls: false,
      sipnav_disable_rate_deck: false,
      sipnav_capacity_group: "1",
      sipnav_block_wireless: false,
      sipnav_dnis_blacklist: false,
      sipnav_remove_cid_name: false,
      sipnav_block_dnc: false,
      sipnav_block_matching_src_dst: "disabled",
      sipnav_attestation_blocking: "filtering_disabled",
      sipnav_disable_call_restrictions_cid: true,
      sipnav_disable_call_restrictions_destination: true,
      sipnav_disable_call_restrictions_ani: false,
      sipnav_ani_blacklist_global: true,
      sipnav_ani_blacklist_custom: true,
      sipnav_ani_blacklist_none: false,
      sipnav_account_ips: [""],
      sipnav_carrier_ips: [""],
      sipnav_revoking: false,
    };
    this.dropdownRef = createRef();
    this.dropdownRefVisibility = createRef();
    this.sipnavStep2BodyRef = createRef();
  }

  async componentDidMount() {
    const previousUrl = sessionStorage.getItem("previousUrl");
    if (previousUrl) {
      this.setState({
        tableLoader: true,
        dataLoaded: false,
        dataFetched: false,
      });

      const urlParams = new URLSearchParams(window.location.search);
      const paramCode = urlParams.get("code");
      const realmId = urlParams.get("realmId");

      if (paramCode) {
        await this.getCallBackData(paramCode, realmId);
      }
      return;
    }
    const servicesResponce = await getAgentSignup(
      auth.getAccount(),
      auth.getToken()
    );
    //console.log("Hash Data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signup_link: servicesResponce.data.data,
        login_url: servicesResponce.data.login_url,
        logo: servicesResponce.data.logo,
        signature_image: servicesResponce.data.signature,
        tableLoader: false,
      });

      const urlParams = new URLSearchParams(window.location.search);
      const paramCode = urlParams.get("code");
      const realmId = urlParams.get("realmId");

      if (paramCode) {
        await this.getCallBackData(paramCode, realmId);
      }
    } else {
      // window.location.replace("/error");
    }
    await this.get_integration_data();
    await this.loadStripeStatus();
    await this.get_smtp_settings();
    await this.loadSipnavStatus();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  // ─── Stripe ─────────────────────────────────────────────────────────────
  // The card is rendered from /integrations/stripe/status rather than a
  // user_integrations row: get_integration_data selects that table without a
  // reseller filter, so a per-reseller row would show on every reseller's grid.
  loadStripeStatus = async () => {
    try {
      const res = await getStripeStatus(auth.getAccount(), auth.getToken());
      const payload = res && res.data;
      if (payload && payload.status === 200 && payload.data) {
        this.setState({ stripeStatus: payload.data });
        if (this.props.setStripeStatus) this.props.setStripeStatus(payload.data);
      }
    } catch (e) {
      console.log("loadStripeStatus error:", e.message);
    }
  };

  onStripeStatusChange = (status) => {
    this.setState({ stripeStatus: status });
    if (this.props.setStripeStatus) this.props.setStripeStatus(status);
  };

  stripeToast = (message, type) => {
    this.setState({ stripeToastMsg: message, stripeToastType: type || "success" });
  };

  openStripeModal = () => {
    if (this.stripeModalRef && this.stripeModalRef.open) this.stripeModalRef.open();
    window.$("#modalStripeIntegration").modal("show");
  };

  disconnectStripeFromCard = () => {
    this.openStripeModal();
  };

  stripeCardLabel = () => {
    const st = this.state.stripeStatus;
    if (!st || !st.connected) return { text: "Connect", cls: "" };
    if (!st.enabled) return { text: "Connected · Paused", cls: "st-paused" };
    return st.mode === "live"
      ? { text: "Connected · Live", cls: "st-live" }
      : { text: "Connected · Test", cls: "st-test" };
  };

  getCallBackData = async (code, realmId) => {
    this.setState({
      errorQuickBooks: "",
      successQuickBooks: "",
    });
    const servicesResponce = await getCallBackData(
      auth.getAccount(),
      auth.getToken(),
      code,
      realmId
    );
    // console.log("getCallBackData: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 400) {
      this.setState({
        errorQuickBooks:
          " There is some error while getting connecting with quick books.",
        successQuickBooks: "",
        connected: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message ===
        "Authorization successful and tokens logged."
    ) {
      this.setState({
        errorQuickBooks: "",
        successQuickBooks: "Authorization successful.",
      });
      setTimeout(() => {
        this.setState({
          errorQuickBooks: "",
          successQuickBooks: "",
        });
        setTimeout(() => {
          this.setState({
            errorQuickBooks: "",
            successQuickBooks: "",
          });

          const previousUrl = sessionStorage.getItem("previousUrl");
          if (previousUrl && previousUrl !== "") {
            window.location.replace(previousUrl);
          } else {
            window.history.replaceState(null, "", window.location.pathname);
            window.location.reload();
          }
        }, 3000);
        //window.history.replaceState(null, "", window.location.pathname);
        //window.location.reload();
      }, 3000);
    } else {
      this.setState({
        errorQuickBooks: "There is some error while getting integration data",
        successQuickBooks: "Success getting integration data.",
      });
    }
  };

  handleQuickBookIntegration = () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    window.$("#modalQuickBookIntegration").modal("show");
  };

  deleteQuickBookIntegration = async () => {
    this.setState({ isProcessing: true });
    const servicesResponse = await deleteQuickBookIntegration(
      auth.getAccount(),
      auth.getToken()
    );

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          successMessage: "Connection successfully revoked.",
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDeleteAlert").modal("hide");
            this.setState({ successMessage: "" });
            window.location.reload();
          }, 3000);
        }
      );
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "Error while connection revoking.",
      });
    } else {
      this.setState({
        errorMessage: "Error while connection revoking.",
      });
    }
  };

  get_integration_data = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getIntegration(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("get_integration_data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting integration data.",
        successMessage: "",
        dataFetched: true,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const integrationTypeList = servicesResponce.data.data.map(
        (integration) => ({
          title: integration.integration_title,
          status: integration.status,
        })
      );

      const availableCategories = [
        ...new Set(
          servicesResponce.data.integrationCategory.map(
            (category) => category.title
          )
        ),
      ];

      this.setState({
        integrations: servicesResponce.data.data,
        getcallbackData: servicesResponce.data.quickLogData,
        errorMessage: "",
        successMessage: "Success getting integration data.",
        dataLoaded: true,
        dataFetched: true,
        integration_type_list: integrationTypeList,
        availableCategories: availableCategories,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting integration data.",
        successMessage: "",
        dataFetched: true,
      });
    }
  };

  getQuickBookAuth = async () => {
    const servicesResponce = await getQuickBookAuth(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("getQuickBookAuth: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      // Open the authUrl in a new tab
      window.open(servicesResponce.data.authUrl, "_blank");
    } else {
      // Handle error case or other conditions if needed
      console.error("There is some error while getting integration data.");
    }
  };

  handleMetabaseIntegration = (integration_id) => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      integration_id: integration_id,
    });
    window.$("#modalMetabaseIntegration").modal("show");
  };

  manageMetabaseConnection = async (integration_id) => {
    this.setState({
      errorQuickBooks: "",
      successQuickBooks: "",
      loading_button_meta: true,
    });
    const servicesResponce = await manageMetabaseConnection(
      auth.getAccount(),
      auth.getToken(),
      integration_id
    );
    // console.log("manageMetabaseConnection: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorQuickBooks: "There is some error while building the connection.",
        successQuickBooks: "",
        loading_button_meta: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "Status updated successfully"
    ) {
      this.setState(
        {
          successQuickBooks: "Connection build successfully.",
          errorQuickBooks: "",
          loading_button_meta: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ successMessage: "" });
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorQuickBooks: "There is some error while building the connection.",
        successQuickBooks: "",
        loading_button_meta: false,
      });
    }
  };

  deleteMetabaseIntegration = async () => {
    this.setState({ isProcessing: true });
    const servicesResponse = await deleteMetabaseIntegration(
      auth.getAccount(),
      auth.getToken(),
      this.state.integration_id
    );

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "Status updated successfully"
    ) {
      this.setState(
        {
          successMessage: "Connection successfully revoked.",
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ successMessage: "" });
            window.location.reload();
          }, 2000);
        }
      );
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "Error while connection revoking.",
      });
    } else {
      this.setState({
        errorMessage: "Error while connection revoking.",
      });
    }
  };

  modalHideMetaDel = () => {
    window.$("#modalMetabaseIntegration").modal("hide");
  };

  regenerate_link = async () => {
    this.setState({
      reg_button: true,
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await regenerateAgentLink(
      auth.getAccount(),
      auth.getToken()
    );
    //console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while updating the signup link.",
        successMessage: "",
        reg_button: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signup_link: servicesResponce.data.data,
        errorMessage: "",
        successMessage: "Link generated successfully.",
        reg_button: false,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while updating the signup link.",
        successMessage: "",
        reg_button: false,
      });
      // window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 5000);
  };

  cancel_link = async () => {
    this.setState({
      cancel_button: true,
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await cancelAgentLink(
      auth.getAccount(),
      auth.getToken()
    );
    //console.log("cancel_link: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while removing the signup link.",
        successMessage: "",
        cancel_button: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signup_link: servicesResponce.data.data,
        errorMessage: "",
        successMessage: "Link removed successfully.",
        cancel_button: false,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while removing the signup link.",
        successMessage: "",
        cancel_button: false,
      });
      // window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 5000);
  };

  get_smtp_settings = async () => {
    this.setState({
      reg_button: true,
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getSmtpSettings(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("get_smtp_settings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting SMTP settings.",
        successMessage: "",
        reg_button: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success" &&
      Array.isArray(servicesResponce.data.data) &&
      servicesResponce.data.data.length > 0
    ) {
      const row = servicesResponce.data.data[0];
      this.setState({
        smtp_host: row.smtp_host || "",
        smtp_user: row.smtp_user || "",
        smtp_password: row.smtp_password || "",
        smtp_method: row.smtp_method || "tls",
        smtp_port: row.smtp_port || "",
        from_email: row.from_email || "",
        is_working: row.is_working || "no",
        super_admin_email: row.super_admin_email,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      (servicesResponce.data.message === "no_record" ||
        servicesResponce.data.message === "not_found" ||
        servicesResponce.data.message === "success")
    ) {
      // No SMTP record configured yet (or success with empty data) — show blank defaults.
      this.setState({
        smtp_host: "",
        smtp_user: "",
        smtp_password: "",
        smtp_method: "tls",
        smtp_port: "",
        from_email: "",
        is_working: "no",
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting SMTP settings.",
        successMessage: "",
        reg_button: false,
      });
    }
  };

  add_smtp_settings = async () => {
    let {
      smtp_host,
      smtp_user,
      smtp_password,
      smtp_method,
      smtp_port,
      from_email,
    } = this.state;
    this.setState({
      SmtpErrorMessage: "",
      SmtpSuccessMessage: "",
      smtp_reg_button: true,
      errorHostName: "",
      errorUser: "",
      errorPassword: "",
    });
    var is_validated = true;

    if (smtp_host === "") {
      this.setState({
        errorHostName: "error",
        SmtpErrorMessage: "SMTP host is required.",
        smtp_reg_button: false,
      });
      is_validated = false;
    } else if (smtp_host !== "") {
      if (this.validateDomain(smtp_host) === false) {
        this.setState({
          errorHostName: "error",
          SmtpErrorMessage: "Invalid domain/host format.",
          smtp_reg_button: false,
        });
        is_validated = false;
      }
    }

    if (smtp_user === "") {
      this.setState({
        errorUser: "error",
        SmtpErrorMessage: "Username is required.",
        smtp_reg_button: false,
      });
      is_validated = false;
    } else if (smtp_user !== "") {
      if (this.validateEmailAdd(smtp_user) === false) {
        //console.log("smtp_user: ", smtp_user);
        this.setState({
          errorUser: "error",
          SmtpErrorMessage: "Invalid username (email) format.",
          smtp_reg_button: false,
        });
        is_validated = false;
      }
    }
    if (smtp_password === "") {
      this.setState({
        errorPassword: "error",
        SmtpErrorMessage: "Password is required.",
        smtp_reg_button: false,
      });
      is_validated = false;
    }
    if (is_validated) {
      const servicesResponce = await addSmtpSettings(
        auth.getAccount(),
        auth.getToken(),
        smtp_host,
        smtp_user,
        smtp_password,
        smtp_method,
        smtp_port,
        from_email
      );
      //console.log("addSmtpSettings: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          SmtpErrorMessage: "There is some error while adding SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_reg_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          SmtpErrorMessage: "",
          SmtpSuccessMessage: "SMTP settings added successfully.",
          smtp_reg_button: false,
        });
      } else {
        this.setState({
          SmtpErrorMessage: "There is some error while adding SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_reg_button: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({ SmtpErrorMessage: "", SmtpSuccessMessage: "" });
    }, 5000);
  };

  //Test SMTP Settings

  verify_smtp_settings = async () => {
    let {
      smtp_host,
      smtp_user,
      smtp_password,
      smtp_method,
      smtp_port,
      from_email,
    } = this.state;
    this.setState({
      SmtpErrorMessage: "",
      SmtpSuccessMessage: "",
      smtp_test_button: true,
      errorHostName: "",
      errorUser: "",
      errorPassword: "",
    });
    var is_validated = true;

    if (smtp_host === "") {
      this.setState({
        errorHostName: "error",
        SmtpErrorMessage: "SMTP host is required.",
        smtp_test_button: false,
      });
      is_validated = false;
    } else if (smtp_host !== "") {
      if (this.validateDomain(smtp_host) === false) {
        this.setState({
          errorHostName: "error",
          SmtpErrorMessage: "Invalid domain/host format.",
          smtp_test_button: false,
        });
        is_validated = false;
      }
    }

    if (smtp_user === "") {
      this.setState({
        errorUser: "error",
        SmtpErrorMessage: "Username is required.",
        smtp_test_button: false,
      });
      is_validated = false;
    } else if (smtp_user !== "") {
      if (this.validateEmailAdd(smtp_user) === false) {
        //console.log("smtp_user: ", smtp_user);
        this.setState({
          errorUser: "error",
          SmtpErrorMessage: "Invalid username (email) format.",
          smtp_test_button: false,
        });
        is_validated = false;
      }
    }
    if (smtp_password === "") {
      this.setState({
        errorPassword: "error",
        SmtpErrorMessage: "Password is required.",
        smtp_test_button: false,
      });
      is_validated = false;
    }
    if (is_validated) {
      const servicesResponce = await verifySmtpSettings(
        auth.getAccount(),
        auth.getToken(),
        smtp_host,
        smtp_user,
        smtp_password,
        smtp_method,
        smtp_port,
        from_email
      );
      //console.log("verifySmtpSettings: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          SmtpErrorMessage: "There is some error while testing SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_test_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          SmtpErrorMessage: "",
          SmtpSuccessMessage: "SMTP settings tested successfully.",
          smtp_test_button: false,
          is_working: "yes",
        });
      } else {
        this.setState({
          SmtpErrorMessage: "There is some error while testing SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_test_button: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({ SmtpErrorMessage: "", SmtpSuccessMessage: "" });
    }, 5000);
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  validateIPAddress = (ipAddress) => {
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const isValid = ipRegex.test(ipAddress);
    //console.log(`Is IP Address valid? ${isValid}`);
    return isValid;
  };

  validateDomain = (domain) => {
    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = domainRegex.test(domain);
    //console.log(`Is domain valid? ${isValid}`);
    if (isValid) {
      return true;
    }
    return false;
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  integration_settings = async (integration_type) => {
    this.setState({
      wholesale_data: "",
      wholesale_title: "",
      wholesale_url: "",
      wholesale_key: "",
      wholesale_auth: "",
      wholesale_active: "",
      wholesale_is_verified: "",
      integration_type: "",
      integration_type_title: "",
    });
    if (integration_type === "voycetel") {
      this.setState({
        integration_type_title: "Lynk Telecom",
      });
      window.$("#modalIntegrationSettings").modal("show");
      await this.wholesale_setup_config(integration_type);
    }
    if (integration_type === "voyceadmins") {
      this.setState({
        integration_type_title: "Lynk AI",
      });
      window.$("#modalIntegrationSettings").modal("show");
      await this.wholesale_setup_config(integration_type);
    }
    if (integration_type === "metabase") {
      this.setState({
        integration_type_title: "Metabase",
      });
      window.$("#modalIntegrationSettingsMeta").modal("show");
      await this.wholesale_setup_config(integration_type);
    }
    if (integration_type === "chatgpt") {
      this.setState({
        integration_type_title: "ChatGpt",
      });
      window.$("#modalIntegrationSettingsChatGpt").modal("show");
      await this.wholesale_setup_config(integration_type);
    }
  };

  SubmitMetadataConfig = async () => {
    const { wholesale_url, wholesale_key, integration_type } = this.state;
    this.setState({
      loading_button: true,
      IntErrorMessage: "",
    });
    if (wholesale_url === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API URL.",
      });
    } /*else if (wholesale_key === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API Key.",
      });
    }*/ else {
      const servicesResponce = await SubmitMetadataConfig(
        auth.getAccount(),
        auth.getToken(),
        wholesale_url,
        wholesale_key,
        integration_type
      );

      // console.log("wholesale_setup_submit: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while updating the details.",
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          IntSuccessMessage:
            "Integration details added / updated successfully.",
          IntErrorMessage: "",
          loading_button: false,
        });
      } else {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while updating the details.",
        });
      }
    }
    setTimeout(() => {
      this.setState({ IntErrorMessage: "", IntSuccessMessage: "" });
      window.location.reload();
    }, 3000);
  };

  SubmitChatGptdataConfig = async () => {
    const { wholesale_key, integration_type } = this.state;
    this.setState({
      loading_button: true,
      IntErrorMessage: "",
    });
    if (wholesale_key === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API Key.",
      });
    } else {
      const encryptedKey = this.encryptApiKey(wholesale_key);
      const servicesResponce = await SubmitChatGptdataConfig(
        auth.getAccount(),
        auth.getToken(),
        encryptedKey,
        integration_type
      );

      // console.log("wholesale_setup_submit: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while updating the details.",
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          IntSuccessMessage:
            "Integration details added / updated successfully.",
          IntErrorMessage: "",
          loading_button: false,
        });
      } else {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while updating the details.",
        });
      }
    }
    setTimeout(() => {
      this.setState({ IntErrorMessage: "", IntSuccessMessage: "" });
      window.location.reload();
    }, 3000);
  };

  encryptApiKey = (value) => {
    if (!value || typeof value !== "string") {
      console.error("encryptApiKey: Invalid value");
      return "";
    }

    try {
      const encrypted = CryptoJS.AES.encrypt(
        value,
        process.env.REACT_APP_SECRET_AES
      ).toString();
      return encrypted;
    } catch (err) {
      console.error("Encryption failed:", err);
      return "";
    }
  };

  decryptApiKey = (encryptedValue) => {
    if (!encryptedValue || typeof encryptedValue !== "string") {
      console.error("decryptApiKey: Invalid encrypted value");
      return "";
    }

    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedValue,
        process.env.REACT_APP_SECRET_AES
      );
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      if (!decrypted) {
        console.error("Decryption resulted in empty string");
        return "";
      }

      return decrypted;
    } catch (err) {
      console.error("Decryption failed:", err);
      return "";
    }
  };

  wholesale_setup_config = async (integration_type) => {
    const servicesResponce = await wholesaleSetupConfig(
      auth.getAccount(),
      auth.getToken(),
      integration_type
    );

    // console.log("wholesale_setup_config: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        formLoader: false,
        IntErrorMessage: "There is some error while getting the details.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const data = servicesResponce.data.data[0];

      let apiKey = data.api_key;
      if (data.integration_type === "chatgpt" && apiKey) {
        apiKey = this.decryptApiKey(apiKey); // Use this.decryptApiKey
      }
      this.setState({
        wholesale_data: servicesResponce.data.data,
        wholesale_title: servicesResponce.data.data[0].integration_title,
        wholesale_url: servicesResponce.data.data[0].api_url,
        wholesale_key: apiKey,
        wholesale_auth: servicesResponce.data.data[0].api_auth,
        wholesale_active: servicesResponce.data.data[0].active,
        wholesale_is_verified: servicesResponce.data.data[0].is_verified,
        integration_type: servicesResponce.data.data[0].integration_type,
        IntErrorMessage: "",
        formLoader: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        wholesale_url: "",
        wholesale_key: "",
        wholesale_auth: "",
        wholesale_is_verified: 0,
        wholesale_active: 0,
        IntErrorMessage: "",
        formLoader: false,
      });
    } else {
      this.setState({
        formLoader: false,
        IntErrorMessage: "There is some error while getting the details.",
      });
    }
  };

  VerifyWholeSaleConfig = async () => {
    const {
      wholesale_url,
      wholesale_key,
      wholesale_auth,
      wholesale_active,
      integration_type,
    } = this.state;
    this.setState({
      loading_button: true,
      IntErrorMessage: "",
    });
    if (wholesale_url === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API URL.",
      });
    } else if (wholesale_key === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API Key.",
      });
    } else if (wholesale_auth === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API Auth.",
      });
    } else {
      const servicesResponce = await VerifyWholeSaleConfig(
        auth.getAccount(),
        auth.getToken(),
        wholesale_url,
        wholesale_key,
        wholesale_auth,
        wholesale_active,
        integration_type
      );

      // console.log("wholesale_setup_verify : ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while verifying the details.",
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          IntSuccessMessage: "Integration details verified successfully.",
          IntErrorMessage: "",
          loading_button: false,
          wholesale_is_verified: 1,
        });
      } else {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while verifying the details.",
        });
      }
    }
    setTimeout(() => {
      this.setState({ IntErrorMessage: "", IntSuccessMessage: "" });
      window.location.reload();
    }, 5000);
  };

  submitWholeSaleConfig = async () => {
    const {
      wholesale_url,
      wholesale_key,
      wholesale_auth,
      wholesale_active,
      integration_type,
    } = this.state;
    this.setState({
      loading_button: true,
      IntErrorMessage: "",
    });
    if (wholesale_url === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API URL.",
      });
    } else if (wholesale_key === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API Key.",
      });
    } else if (wholesale_auth === "") {
      this.setState({
        loading_button: false,
        IntErrorMessage: "Please enter the API Auth.",
      });
    } else {
      const servicesResponce = await SubmitwholesaleConfig(
        auth.getAccount(),
        auth.getToken(),
        wholesale_url,
        wholesale_key,
        wholesale_auth,
        wholesale_active,
        integration_type
      );

      // console.log("wholesale_setup_submit: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while updating the details.",
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          IntSuccessMessage:
            "Integration details added / updated successfully.",
          IntErrorMessage: "",
          loading_button: false,
        });
      } else {
        this.setState({
          loading_button: false,
          IntErrorMessage: "There is some error while updating the details.",
        });
      }
    }
    setTimeout(() => {
      this.setState({ IntErrorMessage: "", IntSuccessMessage: "" });
      window.location.reload();
    }, 5000);
  };

  modalHideDel = () => {
    window.$("#modalQuickBookIntegration").modal("hide");
  };

  manageSubpoenaConnection = (integration_id, actions) => {
    this.setState({
      errorMessageSubpoena: "",
      successMessageSubpoena: "",
      integration_action: actions,
      integration_id: integration_id,
      is_processing_subpoena: false,
    });
    window.$("#modalSubpoenaIntegration").modal("show");
  };

  modalHideSubpoena = () => {
    window.$("#modalSubpoenaIntegration").modal("hide");
  };

  subpoenaIntegration = async (integration_action) => {
    const { integration_id } = this.state;
    this.setState({
      errorMessageSubpoena: "",
      successMessageSubpoena: "",
      is_processing_subpoena: true,
    });
    const servicesResponce = await manageSubpoenaIntegration(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      integration_action
    );
    // console.log("manageSubpoenaIntegration: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageSubpoena:
          "There is some error while updating the integration status.",
        successMessageSubpoena: "",
        is_processing_subpoena: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState(
        {
          successMessageSubpoena: servicesResponce.data.message,
          errorMessageSubpoena: "",
          is_processing_subpoena: true,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorMessageSubpoena:
          "There is some error while updating the integration status",
        successMessageSubpoena: "",
        is_processing_subpoena: false,
      });
    }
  };

  handleVoiceAlertsIntegration = (integration_id) => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      integration_id: integration_id,
      errorMessageVoiceAlerts: "",
      successMessageVoiceAlerts: "",
      is_processing_voicealerts: false,
      loading_button_voicealerts: false,
      enable_fcc_499: 1,
      enable_on_registration: 1,
    });
    window.$("#modalVoiceAlertsSettingsIntegration").modal("show");
  };

  handleVoiceAlertsDisconnect = (integration_id) => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      integration_id: integration_id,
    });
    window.$("#modalVoiceAlertsIntegration").modal("show");
  };

  manageVocieAlertConnection = async (integration_id) => {
    const { enable_fcc_499, enable_on_registration } = this.state;
    this.setState({
      errorQuickBooks: "",
      successQuickBooks: "",
      loading_button: true,
    });
    const servicesResponce = await manageVocieAlertConnection(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      enable_fcc_499,
      enable_on_registration
    );
    // console.log("manageVocieAlertConnection: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorQuickBooks: "There is some error while building the connection.",
        successQuickBooks: "",
        loading_button: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "Status updated successfully"
    ) {
      this.setState(
        {
          successQuickBooks: "Connection build successfully.",
          errorQuickBooks: "",
          loading_button: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ successMessage: "" });
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorQuickBooks: "There is some error while building the connection.",
        successQuickBooks: "",
        loading_button: false,
      });
    }
  };

  deleteVoiceAlertsIntegration = async () => {
    this.setState({ isProcessing: true });
    const servicesResponse = await deleteVoiceAlertsIntegration(
      auth.getAccount(),
      auth.getToken(),
      this.state.integration_id
    );

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "Status updated successfully"
    ) {
      this.setState(
        {
          successMessage: "Connection successfully revoked.",
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ successMessage: "" });
            window.location.reload();
          }, 2000);
        }
      );
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "Error while connection revoking.",
      });
    } else {
      this.setState({
        errorMessage: "Error while connection revoking.",
      });
    }
  };

  modalHideVoiceDel = () => {
    window.$("#modalVoiceAlertsIntegration").modal("hide");
  };

  modalHideVoiceAlertsSettings = () => {
    window.$("#modalVoiceAlertsSettingsIntegration").modal("hide");
  };

  voiceAlertsIntegration = async () => {
    const { integration_id, enable_fcc_499, enable_on_registration } = this.state;
    this.setState({
      errorMessageVoiceAlerts: "",
      successMessageVoiceAlerts: "",
      is_processing_voicealerts: true,
      loading_button_voicealerts: true,
    });
    const servicesResponce = await manageVocieAlertConnection(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      enable_fcc_499,
      enable_on_registration
    );
    // console.log("manageVocieAlertConnection: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "Integration updated successfully"
    ) {
      this.setState({
        is_processing_voicealerts: false,
        loading_button_voicealerts: false,
        successMessageVoiceAlerts: servicesResponce.data.message,
      });
      await this.get_integration_data();
      setTimeout(() => {
        window.$("#modalVoiceAlertsSettingsIntegration").modal("hide");
      }, 2000);
    } else {
      this.setState({
        is_processing_voicealerts: false,
        loading_button_voicealerts: false,
        errorMessageVoiceAlerts: servicesResponce.data.message,
      });
    }
  };

  openVoiceAlertsEditModal = async (integration_type, integration_id) => {
    this.setState({
      errorMessageVoiceAlertsEdit: "",
      successMessageVoiceAlertsEdit: "",
      loading_button_voicealerts_edit: false,
      voicealerts_edit_integration_id: integration_id,
    });
    
    await this.wholesale_setup_config(integration_type);
    
    const { wholesale_data } = this.state;
    if (wholesale_data && wholesale_data.length > 0) {
      // Find FCC 499 integration in the data array
      const fcc499Integration = wholesale_data.find(
        (item) => item.integration_type === "fcc 499"
      );
      
      // Set enable_fcc_499 to 1 if FCC 499 integration is active, otherwise 0
      const enableFcc499 = fcc499Integration && fcc499Integration.active === 1 ? 1 : 0;
      
      // Set enable_on_registration to 1 if is_enabled_on_registration is 1, otherwise 0
      const enableOnRegistration = 
        fcc499Integration && fcc499Integration.is_enabled_on_registration === 1 ? 1 : 0;
      
      this.setState({
        enable_fcc_499: enableFcc499,
        enable_on_registration: enableOnRegistration,
      });
    } else {
      this.setState({
        enable_fcc_499: 0,
        enable_on_registration: 0,
      });
    }
    
    window.$("#modalVoiceAlertsEditIntegration").modal("show");
  };

  modalHideVoiceAlertsEdit = () => {
    window.$("#modalVoiceAlertsEditIntegration").modal("hide");
  };

  saveVoiceAlertsConfig = async () => {
    const { enable_fcc_499, enable_on_registration, voicealerts_edit_integration_id } = this.state;
    this.setState({
      errorMessageVoiceAlertsEdit: "",
      successMessageVoiceAlertsEdit: "",
      loading_button_voicealerts_edit: true,
    });

    try {
      const response = await voicealerts_integration_config(
        auth.getAccount(),
        auth.getToken(),
        voicealerts_edit_integration_id,
        enable_fcc_499,
        enable_on_registration
      );

      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (response.data.status === 404) {
        this.setState({
          errorMessageVoiceAlertsEdit:
            response.data.message || "Failed to update settings.",
          successMessageVoiceAlertsEdit: "",
          loading_button_voicealerts_edit: false,
        });
      } else if (response.data.status === 200) {
        this.setState({
          successMessageVoiceAlertsEdit: "Settings updated successfully.",
          errorMessageVoiceAlertsEdit: "",
          loading_button_voicealerts_edit: false,
        });
        await this.get_integration_data();
        setTimeout(() => {
          this.modalHideVoiceAlertsEdit();
        }, 2000);
      } else {
        this.setState({
          errorMessageVoiceAlertsEdit:
            response.data.message || "Failed to update settings.",
          successMessageVoiceAlertsEdit: "",
          loading_button_voicealerts_edit: false,
        });
      }
    } catch (error) {
      this.setState({
        errorMessageVoiceAlertsEdit: "An error occurred while saving settings.",
        successMessageVoiceAlertsEdit: "",
        loading_button_voicealerts_edit: false,
      });
    }
  };

  setRequestIntegration = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      name: auth.getCompName(),
      email: auth.getEmail(),
      comment: "",
      integration_type: "",
    });
    window.$("#modalRequestIntegration").modal("show");
  };

  saveRequestIntegration = async () => {
    const { name, email, super_admin_email, comment, integration_type } =
      this.state;
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });
    let super_admin_emails = super_admin_email.trim();
    // console.log("super_admin_email: ", super_admin_email);
    if (name === "") {
      this.setState({
        errorMessage: "Please enter the name.",
        successMessage: "",
        disabled: false,
      });
    } else if (email === "") {
      this.setState({
        errorMessage: "Please enter the email address.",
        successMessage: "",
        disabled: false,
      });
    } else if (this.validateEmailAdd(email) === false) {
      this.setState({
        errorMessage: "Please enter the valid email address.",
        successMessage: "",
        disabled: false,
      });
    } else if (super_admin_emails === "") {
      this.setState({
        errorMessage: "Please enter the admin email address.",
        successMessage: "",
        disabled: false,
      });
    } else if (this.validateEmailAdd(super_admin_emails) === false) {
      this.setState({
        errorMessage: "Please enter the valid to email address.",
        successMessage: "",
        disabled: false,
      });
    } else if (integration_type === "") {
      this.setState({
        errorMessage: "Please select the inegration type.",
        successMessage: "",
        disabled: false,
      });
    } else if (comment === "") {
      this.setState({
        errorMessage: "Please enter the comment.",
        successMessage: "",
        disabled: false,
      });
    } else {
      const servicesResponce = await sendRequestIntegration(
        auth.getAccount(),
        auth.getToken(),
        name,
        email,
        super_admin_emails,
        comment,
        integration_type
      );

      // console.log("integrationResponce.data.data: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessage: "There is some error while sending the request.",
          successMessage: "",
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          errorMessage: "",
          successMessage: "Integration request send successfully.",
          disabled: false,
          name: "",
          email: "",
          super_admin_email: "",
          comment: "",
          integration_type: "",
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          errorMessage:
            "There is some error while sending invite to the client.",
          successMessage: "",
          disabled: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 4000);
  };

  handleSearchChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    this.setState({ searchTerm });
  };

  handleFilterChange = (e) => {
    const selectedCategory = e.target.value;
    this.setState({ selectedCategory });
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  };

  toggleDropdownVisibility = () => {
    this.setState((prevState) => ({
      isDropdownOpenVisibility: !prevState.isDropdownOpenVisibility,
    }));
  };

  handleClickOutside = (event) => {
    // If the click happens outside the dropdown, close it
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ isDropdownOpen: false });
    }
  };

  handleClickOutsideVisibility = (event) => {
    // If the click happens outside the dropdown, close it
    if (
      this.dropdownRefVisibility.current &&
      !this.dropdownRefVisibility.current.contains(event.target)
    ) {
      this.setState({ isDropdownOpen: false });
    }
  };

  manageZapierConnection = (integration_id, actions) => {
    this.setState({
      errorMessageZapier: "",
      successMessageZapier: "",
      integration_action: actions,
      integration_id: integration_id,
      is_processing_zapier: false,
    });
    window.$("#modalZapierIntegration").modal("show");
  };

  modalHideZapier = () => {
    window.$("#modalZapierIntegration").modal("hide");
  };

  zapierIntegration = async (integration_action) => {
    const { integration_id } = this.state;
    this.setState({
      errorMessageZapier: "",
      successMessageZapier: "",
      is_processing_zapier: true,
    });
    const servicesResponce = await manageZapierIntegration(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      integration_action
    );
    // console.log("manageZapierIntegration: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageZapier:
          "There is some error while updating the integration status.",
        successMessageZapier: "",
        is_processing_zapier: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState(
        {
          successMessageZapier: servicesResponce.data.message,
          errorMessageZapier: "",
          is_processing_zapier: true,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorMessageZapier:
          "There is some error while updating the integration status",
        successMessageZapier: "",
        is_processing_zapier: false,
      });
    }
  };

  openLinkInNewTab = (link) => {
    window.open(link, "_blank");
  };

  managePrivateConnection = (integration_id, actions) => {
    this.setState({
      errorMessagePrivate: "",
      successMessagePrivate: "",
      integration_action: actions,
      integration_id: integration_id,
      is_processing_private: false,
    });
    window.$("#modalPrivateIntegration").modal("show");
  };

  modalHidePrivate = () => {
    window.$("#modalPrivateIntegration").modal("hide");
  };

  privateIntegration = async (integration_action) => {
    const { integration_id } = this.state;
    this.setState({
      errorMessagePrivate: "",
      successMessagePrivate: "",
      is_processing_private: true,
    });
    const servicesResponce = await managePrivateIntegration(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      integration_action
    );
    // console.log("managePrivateIntegration: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessagePrivate:
          "There is some error while updating the integration status.",
        successMessagePrivate: "",
        is_processing_private: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState(
        {
          successMessagePrivate: servicesResponce.data.message,
          errorMessagePrivate: "",
          is_processing_private: true,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorMessagePrivate:
          "There is some error while updating the integration status",
        successMessagePrivate: "",
        is_processing_private: false,
      });
    }
  };

  manageConversationalConnection = (integration_id, actions) => {
    this.setState({
      errorMessageConversational: "",
      successMessageConversational: "",
      integration_action: actions,
      integration_id: integration_id,
      is_processing_conversational: false,
    });
    window.$("#modalConversationalIntegration").modal("show");
  };

  modalHideConversational = () => {
    window.$("#modalConversationalIntegration").modal("hide");
  };

  manageTwilioConnection = (integration_id, actions) => {
    this.setState({
      errorMessageTwilio: "",
      successMessageTwilio: "",
      integration_action: actions,
      integration_id: integration_id,
      is_processing_twilio: false,
    });
    window.$("#modalTwilioIntegration").modal("show");
  };

  modalHideTwilio = () => {
    window.$("#modalTwilioIntegration").modal("hide");
  };

  manageFcc499Connection = (integration_id, actions) => {
    this.setState({
      errorMessageFcc499: "",
      successMessageFcc499: "",
      integration_action: actions,
      integration_id: integration_id,
      is_processing_fcc499: false,
      loading_button_fcc499: false,
      enable_on_registration: 1,
    });
    window.$("#modalFcc499Integration").modal("show");
  };

  modalHideFcc499 = () => {
    window.$("#modalFcc499Integration").modal("hide");
  };

  manageTwilioIntegration = async (integration_action) => {
    const { integration_id } = this.state;
    this.setState({
      errorMessageTwilio: "",
      successMessageTwilio: "",
      is_processing_twilio: true,
    });
    const servicesResponce = await manageTwilioIntegration(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      integration_action
    );
    // console.log("managePrivateIntegration: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageTwilio:
          "There is some error while updating the integration status.",
        successMessageTwilio: "",
        is_processing_twilio: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState(
        {
          successMessageTwilio: servicesResponce.data.message,
          errorMessageTwilio: "",
          is_processing_twilio: true,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorMessageTwilio:
          "There is some error while updating the integration status",
        successMessageTwilio: "",
        is_processing_twilio: false,
      });
    }
  };

  fcc499Integration = async (integration_action) => {
    const { integration_id, enable_on_registration } = this.state;
    this.setState({
      errorMessageFcc499: "",
      successMessageFcc499: "",
      is_processing_fcc499: true,
      loading_button_fcc499: true,
    });
    const servicesResponce = await manageFcc499Integration(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      integration_action,
      enable_on_registration
    );
    // console.log("manageFcc499Integration: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageFcc499:
          "There is some error while updating the integration status.",
        successMessageFcc499: "",
        is_processing_fcc499: false,
        loading_button_fcc499: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState(
        {
          successMessageFcc499: servicesResponce.data.message,
          errorMessageFcc499: "",
          is_processing_fcc499: true,
          loading_button_fcc499: true,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorMessageFcc499:
          "There is some error while updating the integration status",
        successMessageFcc499: "",
        is_processing_fcc499: false,
        loading_button_fcc499: false,
      });
    }
  };

  openFcc499EditModal = async (integration_type, integration_id) => {
    this.setState({
      errorMessageFcc499Edit: "",
      successMessageFcc499Edit: "",
      loading_button_fcc499_edit: false,
      fcc499_edit_integration_id: integration_id,
    });
    
    await this.wholesale_setup_config(integration_type);
    
    const { wholesale_data } = this.state;
    if (wholesale_data && wholesale_data.length > 0) {
      this.setState({
        is_enabled_on_registration: wholesale_data[0].is_enabled_on_registration || 0,
      });
    } else {
      this.setState({
        is_enabled_on_registration: 0,
      });
    }
    
    window.$("#modalFcc499EditIntegration").modal("show");
  };

  modalHideFcc499Edit = () => {
    window.$("#modalFcc499EditIntegration").modal("hide");
  };

  saveFcc499Config = async () => {
    const { is_enabled_on_registration, fcc499_edit_integration_id } = this.state;
    this.setState({
      errorMessageFcc499Edit: "",
      successMessageFcc499Edit: "",
      loading_button_fcc499_edit: true,
    });

    try {
      const servicesResponse = await fcc_499_integration_config(
        auth.getAccount(),
        auth.getToken(),
        fcc499_edit_integration_id,
        is_enabled_on_registration
      );

      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponse.data.status === 404) {
        this.setState({
          errorMessageFcc499Edit:
            "There is some error while updating the settings.",
          successMessageFcc499Edit: "",
          loading_button_fcc499_edit: false,
        });
      } else if (servicesResponse.data.status === 200) {
        this.setState(
          {
            successMessageFcc499Edit: "Settings updated successfully.",
            errorMessageFcc499Edit: "",
            loading_button_fcc499_edit: true,
          },
          () => {
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        );
      } else {
        this.setState({
          errorMessageFcc499Edit: "Something went wrong, please try again.",
          successMessageFcc499Edit: "",
          loading_button_fcc499_edit: false,
        });
      }
    } catch (error) {
      this.setState({
        errorMessageFcc499Edit: "Failed to update settings.",
        successMessageFcc499Edit: "",
        loading_button_fcc499_edit: false,
      });
    }
  };

  chatgptConversational = async (integration_action) => {
    const { integration_id } = this.state;
    this.setState({
      errorMessageConversational: "",
      successMessageConversational: "",
      is_processing_conversational: true,
    });
    const servicesResponce = await manageConversationalIntegration(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      integration_action
    );
    // console.log("managePrivateIntegration: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageConversational:
          "There is some error while updating the integration status.",
        successMessageConversational: "",
        is_processing_conversational: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState(
        {
          successMessageConversational: servicesResponce.data.message,
          errorMessageConversational: "",
          is_processing_conversational: true,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorMessageConversational:
          "There is some error while updating the integration status",
        successMessageConversational: "",
        is_processing_conversational: false,
      });
    }
  };

  manageChatGptConnection = (integration_id, actions) => {
    this.setState({
      errorMessageChatgpt: "",
      successMessageChatgpt: "",
      integration_action: actions,
      integration_id: integration_id,
      is_processing_chatgpt: false,
    });
    window.$("#modalChatgptIntegration").modal("show");
  };

  modalHideChatgpt = () => {
    window.$("#modalChatgptIntegration").modal("hide");
  };

  chatgptIntegration = async (integration_action) => {
    const { integration_id } = this.state;
    this.setState({
      errorMessageChatgpt: "",
      successMessageChatgpt: "",
      is_processing_chatgpt: true,
    });
    const servicesResponce = await manageChatgptIntegration(
      auth.getAccount(),
      auth.getToken(),
      integration_id,
      integration_action
    );
    // console.log("managePrivateIntegration: ", servicesResponce.data);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageChatgpt:
          "There is some error while updating the integration status.",
        successMessageChatgpt: "",
        is_processing_chatgpt: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState(
        {
          successMessageChatgpt: servicesResponce.data.message,
          errorMessageChatgpt: "",
          is_processing_chatgpt: true,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      );
    } else {
      this.setState({
        errorMessageChatgpt:
          "There is some error while updating the integration status",
        successMessageChatgpt: "",
        is_processing_chatgpt: false,
      });
    }
  };

  openIntegrationInfo = (integration) => {
    this.setState({ selectedIntegration: integration, showInfoModal: true });
  };

  closeIntegrationInfo = () => {
    this.setState({ selectedIntegration: null, showInfoModal: false });
  };

  handleEyeClickChatGpt = () => {
    // If already shown, just toggle back to hidden
    if (this.state.passwordShownChatGpt) {
      this.setState({ passwordShownChatGpt: false });
      return;
    }

    // Check localStorage timestamp
    const lastVerifiedAt = localStorage.getItem("passwordVerifiedAtGpt");
    const now = new Date();

    if (lastVerifiedAt) {
      const diffMinutes = (now - new Date(lastVerifiedAt)) / (1000 * 60);
      if (diffMinutes <= 30) {
        // ✅ Already verified within 30 min
        this.setState({
          passwordShownChatGpt: true,
          askVerify: false,
        });
        return;
      }
    }

    // ❌ Expired or never verified → show password prompt
    this.setState({
      askVerify: true,
      loginPassword: "",
      loginPasswordError: "",
    });
  };

  handleVerifyPasswordChange = (e) => {
    this.setState({ loginPassword: e.target.value });
  };

  verifyLoginPassword = async () => {
    const { loginPassword } = this.state;

    this.setState({
      loginPasswordError: "",
      verifyingPassword: true,
    });

    if (loginPassword === "") {
      this.setState({
        loginPasswordError: "Password is required.",
        verifyingPassword: false,
      });
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "verify_password",
        {
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
          accountno: auth.getAccount(),
          password: loginPassword,
        }
      );

      if (response.data.status === 200 && response.data.message === "success") {
        const now = new Date().toISOString();
        localStorage.setItem("passwordVerifiedAtGpt", now);

        this.setState({
          passwordShownChatGpt: true,
          askVerify: false,
          loginPassword: "",
          verifyingPassword: false,
        });
      } else {
        this.setState({
          loginPasswordError: "Invalid password. Please try again.",
          verifyingPassword: false,
        });
      }
    } catch (error) {
      console.error("Password verification error:", error);
      this.setState({
        loginPasswordError: "Error verifying password. Please try again.",
        verifyingPassword: false,
      });
    }
  };

  // ─── SIPNav Integration ───────────────────────────────────────────────────

  loadSipnavStatus = async () => {
    try {
      const res = await getOutboundSBCIntegration(
        auth.getAccount(),
        auth.getToken()
      );
      if (res.data.status === 200 && res.data.data) {
        const data = res.data.data;
        const isEnabled = data.is_enabled === 1;
        const dcr = (data.disable_call_restrictions || '').split(',').map(s => s.trim());
        const ani = (data.ani_blacklist || '').split(',').map(s => s.trim());
        const accountIps = data.account_ips ? data.account_ips.split(',').map(s => s.trim()).filter(Boolean) : [""];
        const carrierIps = data.carrier_ips ? data.carrier_ips.split(',').map(s => s.trim()).filter(Boolean) : [""];
        this.setState({
          sipnav_step1_saved: isEnabled,
          sipnav_connected: isEnabled,
          sipnav_api_url_saved: data.api_url || "",
          sipnav_username_saved: data.username || "",
          sipnav_documentation_url: data.documentation_url || "",
          sipnav_api_url: data.api_url || "",
          sipnav_username: data.username || "",
          // Step 2 fields — restored from DB so re-enabling shows last saved values
          sipnav_cps_limit: data.cps_limit ? String(data.cps_limit) : "10",
          sipnav_session_limit: data.session_limit ? String(data.session_limit) : "100",
          sipnav_no_call_progress: data.no_call_progress ? String(data.no_call_progress) : "12",
          sipnav_ring_time: data.ring_time ? String(data.ring_time) : "30",
          sipnav_enforce_cid_block: data.enforce_cid_block !== undefined ? Boolean(data.enforce_cid_block) : true,
          sipnav_cid_block_min_asr: data.cid_block_min_asr ? String(data.cid_block_min_asr) : "10",
          sipnav_cid_block_min_acd: data.cid_block_min_acd ? String(data.cid_block_min_acd) : "15",
          sipnav_cid_block_max_sdp: data.cid_block_max_sdp ? String(data.cid_block_max_sdp) : "30",
          sipnav_international_calls: Boolean(data.international_calls),
          sipnav_disable_rate_deck: Boolean(data.disable_rate_deck),
          sipnav_capacity_group: data.capacity_group ? String(data.capacity_group) : "1",
          sipnav_block_wireless: Boolean(data.block_wireless),
          sipnav_dnis_blacklist: Boolean(data.dnis_blacklist),
          sipnav_remove_cid_name: Boolean(data.remove_cid_name),
          sipnav_block_dnc: Boolean(data.block_dnc),
          sipnav_block_matching_src_dst: data.block_matching_src_dst || "disabled",
          sipnav_attestation_blocking: data.attestation_blocking || "filtering_disabled",
          sipnav_disable_call_restrictions_cid: dcr.includes('cid'),
          sipnav_disable_call_restrictions_destination: dcr.includes('destination'),
          sipnav_disable_call_restrictions_ani: dcr.includes('ani'),
          sipnav_ani_blacklist_global: ani.includes('global'),
          sipnav_ani_blacklist_custom: ani.includes('custom'),
          sipnav_ani_blacklist_none: ani.includes('none'),
          sipnav_account_ips: accountIps,
          sipnav_carrier_ips: carrierIps,
        });
      }
    } catch (e) {
      // silently fail
    }
  };

  openSipnavModal = () => {
    if (this.state.sipnav_connected) {
      // Already active — go straight to Step 2
      this.setState({ sipnav_step2_error: "", sipnav_step2_success: "" });
      window.$("#modalSipnavStep2").modal("show");
    } else {
      // Always show Step 1. Pre-fill saved values if they exist so the user
      // sees their last used credentials; blank only when never connected before.
      this.setState({
        sipnav_step1_error: "",
        sipnav_step1_success: "",
        sipnav_password: "",
        sipnav_show_password: false,
      });
      window.$("#modalSipnavStep1").modal("show");
    }
  };

  openSipnavStep1ForEdit = () => {
    window.$("#modalSipnavStep2").modal("hide");
    this.setState({
      sipnav_step1_error: "",
      sipnav_step1_success: "",
      sipnav_password: "",
      sipnav_show_password: false,
    });
    window.$("#modalSipnavStep1").modal("show");
  };

  submitSipnavCredentials = async () => {
    const {
      sipnav_api_url,
      sipnav_username,
      sipnav_password,
      sipnav_documentation_url,
    } = this.state;

    if (!sipnav_api_url || !sipnav_username || !sipnav_password) {
      this.setState({ sipnav_step1_error: "API URL, Username and Password are required.", sipnav_step1_success: "" });
      return;
    }

    // Shared URL validator: must be https with a valid hostname and known TLD
    const _knownTlds = new Set(["com","net","org","io","co","us","uk","ca","de","fr","au","in","jp","br","ru","nl","se","no","dk","fi","be","ch","at","es","it","pt","pl","cz","sk","hu","ro","bg","hr","si","rs","gr","tr","il","za","sg","hk","tw","kr","mx","ar","cl","pe","nz","ie","is","lt","lv","ee","cy","mt","lu","li","mc","sm","va","ad","ge","am","az","by","kz","kg","tj","tm","uz","mn","af","pk","bd","lk","np","mm","kh","la","vn","th","ph","my","id","bn","tl","fj","pg","ws","to","vu","sb","ki","nr","tv","pw","fm","mh","ck","nu","tk","wf","pf","nc","re","yt","gp","mq","gf","pm","mf","bl","sx","cw","aw","bq","ai","vg","vi","pr","tc","ky","bm","ms","gd","bb","lc","vc","ag","dm","kn","jm","ht","do","cu","bs","tt","gw","gn","sl","lr","ci","gh","tg","bj","ng","cm","ga","cg","cd","ao","zm","zw","mz","mg","mu","sc","km","dj","so","et","er","sd","ss","ug","ke","tz","rw","bi","mw","ls","sz","bw","na","sn","gm","ml","bf","ne","mr","cv","st","gq","cf","td","ly","tn","dz","ma","eg","jo","lb","sy","iq","ir","sa","ye","om","ae","qa","kw","bh","info","biz","name","pro","aero","coop","museum","travel","jobs","mobi","tel","xxx","cat","post","edu","gov","mil","int","arpa","app","dev","tech","online","store","shop","site","web","blog","cloud","digital","media","news","agency","design","health","finance","legal","estate","fund","ventures","capital","partners","group","global","world","solutions","services","systems","network","consulting","management","support","tools","works","studio","space","zone","live","page","link","click","email","social","team","community","company","business","center","place","today","life","guru","expert","coach","tips","help","care","plus","prime","top","best","first","one","two","now","next","new","blue","red","green","gold","black","white","pink","show","play","stream","video","photo","pics","art","fashion","style","beauty","food","coffee","pizza","beer","wine","fit","yoga","run","golf","ski","surf","bike","camp","fish","hunt","farm","land","earth","city","town","village","country","home","house","garden","kitchen","bath","market","mall","auction","deal","sale","buy","sell","trade","exchange","bank","money","pay","cash","loan","credit","tax","law","legal","court","jury","judge","attorney","lawyer","doctor","dentist","vet","hospital","clinic","pharmacy","vision","dental","med","spa","salon","barber","tattoo","piercing","gym","sport","club","league","fan","tickets","events","wedding","party","dance","music","band","rock","jazz","hiphop","pop","classical","folk","blues","soul","gospel","opera","theater","cinema","film","movie","radio","podcast","press","magazine","book","author","wiki","forum","chat","mail","message","sms","phone","call","cam","pic","gallery","library","school","college","university","academy","training","course","class","study","learn","teach","tutor","mentor","guide","master","ninja","hacker","geek","nerd","lover"]);
    const _isValidSipnavUrl = (url) => {
      let parsed;
      try { parsed = new URL(url); } catch { return false; }
      if (parsed.protocol !== "https:") return false;
      const parts = parsed.hostname.split(".");
      const tld = parts[parts.length - 1].toLowerCase();
      return parts.length >= 2 && _knownTlds.has(tld);
    };

    if (!_isValidSipnavUrl(sipnav_api_url)) {
      this.setState({ sipnav_step1_error: "Please enter a valid URL.", sipnav_step1_success: "" });
      return;
    }

    if (sipnav_documentation_url && !_isValidSipnavUrl(sipnav_documentation_url)) {
      this.setState({ sipnav_step1_error: "Please enter a valid Documentation URL.", sipnav_step1_success: "" });
      return;
    }

    // Username must start with a letter
    if (!/^[a-zA-Z]/.test(sipnav_username)) {
      this.setState({ sipnav_step1_error: "Username must start with a letter.", sipnav_step1_success: "" });
      return;
    }

    // Password: at least 8 characters, 1 uppercase, 1 number, 1 special character
    // if (sipnav_password.length < 8) {
    //   this.setState({ sipnav_step1_error: "Password must be at least 8 characters long." });
    //   return;
    // }
    // if (!/[A-Z]/.test(sipnav_password)) {
    //   this.setState({ sipnav_step1_error: "Password must contain at least one uppercase letter." });
    //   return;
    // }
    // if (!/[0-9]/.test(sipnav_password)) {
    //   this.setState({ sipnav_step1_error: "Password must contain at least one number." });
    //   return;
    // }
    // if (!/[^a-zA-Z0-9]/.test(sipnav_password)) {
    //   this.setState({ sipnav_step1_error: "Password must contain at least one special character." });
    //   return;
    // }

    this.setState({ sipnav_loading: true, sipnav_step1_error: "", sipnav_step1_success: "" });
    try {
      const res = await authenticateOutboundSBC(
        auth.getAccount(),
        auth.getToken(),
        sipnav_api_url,
        sipnav_username,
        sipnav_password,
        this.state.sipnav_documentation_url || ""
      );
      
      if (res.data.status === 200) {
        // Authentication successful
        this.setState({
          sipnav_loading: false,
          sipnav_step1_success: "Authentication successful! You can now configure SipNav settings.",
          sipnav_step1_saved: true,
          sipnav_api_url_saved: sipnav_api_url,
          sipnav_username_saved: sipnav_username,
          sipnav_password: "", // Clear password from state
        });
        
        // Wait 5 seconds to show success message, then proceed to Step 2
        setTimeout(() => {
          window.$("#modalSipnavStep1").modal("hide");
          // Only clear error/success banners — keep Step 2 field values as-is
          // so re-enabling shows the last saved settings instead of defaults
          this.setState({
            sipnav_step2_error: "",
            sipnav_step2_success: "",
            sipnav_step1_success: "",
          });
          window.$("#modalSipnavStep2").modal("show");
        }, 2000);
      } else if (res.data.status === 401) {
        // Unauthorized - Invalid credentials
        this.setState({
          sipnav_loading: false,
          sipnav_step1_error: res.data.error || "Authentication failed. Please check your credentials.",
          sipnav_step1_success: "",
        });
      } else if (res.data.status === 422) {
        // Validation errors
        let errorMessage = res.data.error || "Validation failed";
        
        // If there are specific validation errors, show them
        if (res.data.validationErrors) {
          const errors = res.data.validationErrors;
          const errorMessages = [];
          
          if (errors.username) {
            errorMessages.push(`Username: ${errors.username.join(", ")}`);
          }
          if (errors.password) {
            errorMessages.push(`Password: ${errors.password.join(", ")}`);
          }
          
          if (errorMessages.length > 0) {
            errorMessage = errorMessages.join("; ");
          }
        }
        
        this.setState({
          sipnav_loading: false,
          sipnav_step1_error: errorMessage,
          sipnav_step1_success: "",
        });
      } else if (res.data.status === 500) {
        // Internal server error (database errors, etc.)
        this.setState({
          sipnav_loading: false,
          sipnav_step1_error: res.data.error || "Internal server error. Please try again or contact support.",
          sipnav_step1_success: "",
        });
      } else if (res.data.status === 406) {
        // Request error
        this.setState({
          sipnav_loading: false,
          sipnav_step1_error: res.data.error || "Invalid request. Please check your input.",
          sipnav_step1_success: "",
        });
      } else {
        // Other errors
        this.setState({
          sipnav_loading: false,
          sipnav_step1_error: res.data.error || res.data.message || "Failed to authenticate with SipNav API.",
          sipnav_step1_success: "",
        });
      }
    } catch (e) {
      // Network or other errors
      let errorMessage = "An error occurred while connecting to SipNav.";
      
      if (e.response) {
        // Server responded with error
        if (e.response.data && e.response.data.error) {
          errorMessage = e.response.data.error;
        } else if (e.response.data && e.response.data.message) {
          errorMessage = e.response.data.message;
        } else {
          errorMessage = `Server error: ${e.response.status}`;
        }
      } else if (e.request) {
        // Request was made but no response
        errorMessage = "No response from server. Please check your connection.";
      } else {
        // Something else happened
        errorMessage = e.message || "An unexpected error occurred.";
      }
      
      this.setState({ 
        sipnav_loading: false, 
        sipnav_step1_error: errorMessage,
        sipnav_step1_success: "",
      });
    }
  };

  submitSipnavSettings = async () => {
    const {
      sipnav_cps_limit,
      sipnav_session_limit,
      sipnav_no_call_progress,
      sipnav_ring_time,
      sipnav_enforce_cid_block,
      sipnav_cid_block_min_asr,
      sipnav_cid_block_min_acd,
      sipnav_cid_block_max_sdp,
      sipnav_international_calls,
      sipnav_disable_rate_deck,
      sipnav_capacity_group,
      sipnav_block_wireless,
      sipnav_dnis_blacklist,
      sipnav_remove_cid_name,
      sipnav_block_dnc,
      sipnav_block_matching_src_dst,
      sipnav_attestation_blocking,
      sipnav_disable_call_restrictions_cid,
      sipnav_disable_call_restrictions_destination,
      sipnav_disable_call_restrictions_ani,
      sipnav_ani_blacklist_global,
      sipnav_ani_blacklist_custom,
      sipnav_ani_blacklist_none,
      sipnav_account_ips,
      sipnav_carrier_ips,
    } = this.state;

    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const isValidIp = (ip) => {
      if (!ipv4Regex.test(ip)) return false;
      return ip.split(".").every((octet) => Number(octet) >= 0 && Number(octet) <= 255);
    };

    const filledAccountIps = sipnav_account_ips.map((ip) => ip.trim()).filter((ip) => ip !== "");
    if (filledAccountIps.length === 0) {
      this.setState({ sipnav_step2_error: "At least one Account IP is required." }, () => {
        if (this.sipnavStep2BodyRef.current) this.sipnavStep2BodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      });
      return;
    }
    const invalidAccountIp = filledAccountIps.find((ip) => !isValidIp(ip));
    if (invalidAccountIp) {
      this.setState({ sipnav_step2_error: `Invalid Account IP: "${invalidAccountIp}". Must be a valid IPv4 address.` }, () => {
        if (this.sipnavStep2BodyRef.current) this.sipnavStep2BodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      });
      return;
    }

    const filledCarrierIps = sipnav_carrier_ips.map((ip) => ip.trim()).filter((ip) => ip !== "");
    const invalidCarrierIp = filledCarrierIps.find((ip) => !isValidIp(ip));
    if (invalidCarrierIp) {
      this.setState({ sipnav_step2_error: `Invalid Carrier IP: "${invalidCarrierIp}". Must be a valid IPv4 address.` }, () => {
        if (this.sipnavStep2BodyRef.current) this.sipnavStep2BodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      });
      return;
    }

    this.setState({ sipnav_loading: true, sipnav_step2_error: "" });
    try {
      const res = await saveOutboundSBCSettings(
        auth.getAccount(),
        auth.getToken(),
        sipnav_cps_limit,
        sipnav_session_limit,
        sipnav_no_call_progress,
        sipnav_ring_time,
        sipnav_enforce_cid_block,
        sipnav_cid_block_min_asr,
        sipnav_cid_block_min_acd,
        sipnav_cid_block_max_sdp,
        sipnav_international_calls,
        sipnav_disable_rate_deck,
        sipnav_capacity_group,
        sipnav_block_wireless,
        sipnav_dnis_blacklist,
        sipnav_remove_cid_name,
        sipnav_block_dnc,
        sipnav_block_matching_src_dst,
        sipnav_attestation_blocking,
        [sipnav_disable_call_restrictions_cid ? 'cid' : '', sipnav_disable_call_restrictions_destination ? 'destination' : '', sipnav_disable_call_restrictions_ani ? 'ani' : ''].filter(Boolean).join(','),
        [sipnav_ani_blacklist_global ? 'global' : '', sipnav_ani_blacklist_custom ? 'custom' : '', sipnav_ani_blacklist_none ? 'none' : ''].filter(Boolean).join(',') || 'none',
        sipnav_account_ips.join(','), // Convert array to comma-separated string
        sipnav_carrier_ips.join(',')  // Convert array to comma-separated string
      );
      if (res.data.status === 200) {
        this.setState(
          {
            sipnav_loading: false,
            sipnav_connected: true,
            sipnav_step2_success: "SIPNav integration enabled successfully.",
          },
          () => { if (this.sipnavStep2BodyRef.current) this.sipnavStep2BodyRef.current.scrollTo({ top: 0, behavior: "smooth" }); }
        );
        // Refresh menu to show sipnav-related items
        this.refreshLeftMenu();
        setTimeout(() => {
          window.$("#modalSipnavStep2").modal("hide");
          this.setState({ sipnav_step2_success: "" });
        }, 2000);
      } else {
        this.setState(
          { sipnav_loading: false, sipnav_step2_error: res.data.message || "Failed to save settings." },
          () => { if (this.sipnavStep2BodyRef.current) this.sipnavStep2BodyRef.current.scrollTo({ top: 0, behavior: "smooth" }); }
        );
      }
    } catch (e) {
      this.setState(
        { sipnav_loading: false, sipnav_step2_error: "An error occurred." },
        () => { if (this.sipnavStep2BodyRef.current) this.sipnavStep2BodyRef.current.scrollTo({ top: 0, behavior: "smooth" }); }
      );
    }
  };

  revokeSipnav = async () => {
    this.setState({ sipnav_revoking: true });
    try {
      await revokeOutboundSBCIntegration(auth.getAccount(), auth.getToken());
      // credentials remain in DB, only disable — step1 stays saved
      this.setState({ sipnav_connected: false, sipnav_step1_saved: false, sipnav_revoking: false });
      // Refresh menu to hide sipnav-related items
      this.refreshLeftMenu();
    } catch (e) {
      this.setState({ sipnav_revoking: false });
    }
  };

  refreshLeftMenu = async () => {
    try {
      let user_type = auth.getUserType();
      let acctno = auth.getAccount();
      if (user_type === "Sub") {
        acctno = auth.getSubUserAccount();
      }
      const res = await resellerLeftMenu(acctno, auth.getToken(), auth.getEmail());
      if (res.data.status === 200 && res.data.message === "success" && res.data.data.length > 0) {
        this.props.setLeftMenu(res.data.data);
      }
    } catch (error) {
      console.error("Error refreshing menu:", error);
    }
  };

  handleNumberChange = (e) => {
    const { name, value } = e.target;
    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
      const maxByField = { sipnav_cps_limit: 50, sipnav_session_limit: 500 };
      const max = maxByField[name];
      if (max !== undefined && Number(value) > max) return;
      this.setState({ [name]: value });
    }
  };

  handleSipnavToggle = (fieldName) => {
    this.setState(prevState => ({ [fieldName]: !prevState[fieldName] }));
  };

  addSipnavIP = (type) => {
    const fieldName = type === 'account' ? 'sipnav_account_ips' : 'sipnav_carrier_ips';
    this.setState(prevState => ({
      [fieldName]: [...prevState[fieldName], "0.0.0.0"]
    }));
  };

  removeSipnavIP = (type, index) => {
    const fieldName = type === 'account' ? 'sipnav_account_ips' : 'sipnav_carrier_ips';
    this.setState(prevState => ({
      [fieldName]: prevState[fieldName].filter((_, i) => i !== index)
    }));
  };

  handleSipnavIPChange = (type, index, value) => {
    const fieldName = type === 'account' ? 'sipnav_account_ips' : 'sipnav_carrier_ips';

    // Strip anything that isn't a digit or dot
    const stripped = value.replace(/[^0-9.]/g, "");

    // Clamp each octet to 0–255 as the user types
    const clamped = stripped
      .split(".")
      .map((part, i, arr) => {
        if (part === "") return part;
        const num = parseInt(part, 10);
        if (isNaN(num)) return "";
        // Only clamp complete octets (don't clamp mid-type unless clearly over 255)
        if (num > 255) return "255";
        return String(num);
      })
      .slice(0, 4) // max 4 octets
      .join(".");

    this.setState(prevState => {
      const newIPs = [...prevState[fieldName]];
      newIPs[index] = clamped;
      return { [fieldName]: newIPs };
    });
  };

  // ─────────────────────────────────────────────────────────────────────────

  render() {
    const {
      integrations,
      dataLoaded,
      dataFetched,
      getcallbackData,
      searchTerm,
      selectedCategory,
    } = this.state;

    if (!dataLoaded && !dataFetched) {
      return (
        <div className="nk-content ">
          <div className="container-fluid">
            <div className="nk-content-inner">
              <div className="nk-content-body">
                {this.state.errorQuickBooks !== "" ? (
                  <div className="example-alert">
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{this.state.errorQuickBooks}</p>
                      </div>
                    </div>
                  </div>
                ) : null}

                {this.state.successQuickBooks !== "" ? (
                  <div className="example-alert">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successQuickBooks}</p>
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="text-center" style={{ marginTop: "20%" }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    /* Stripe is listed from user_integrations like every other integration, so
       the card only appears once a row exists for it. The one thing that does
       not come from that row is `active`: whether the reseller is connected is
       decided by whether keys are held, which /integrations/stripe/status
       answers. get_integration_data returns the rows of every reseller, so the
       Stripe rows are collapsed to a single card. */
    const allRows = integrations || [];
    const stripeRows = allRows.filter((i) => i.integration_type === "stripe");
    const integrationsWithStripe = allRows
      .filter((i) => i.integration_type !== "stripe")
      .concat(
        stripeRows.length
          ? [
              Object.assign({}, stripeRows[0], {
                active:
                  this.state.stripeStatus && this.state.stripeStatus.connected ? 1 : 0,
              }),
            ]
          : []
      );

    const filteredIntegrations = integrationsWithStripe.filter((integration) => {
      const matchesSearchTerm = integration.integration_title
        .toLowerCase()
        .includes(searchTerm || "");
      const matchesCategory =
        selectedCategory === "all" || integration.category === selectedCategory;
      const matchesVisibility =
        this.state.selectedVisibility === "all" ||
        integration.visibility === this.state.selectedVisibility;
      // Exclude FCC 499 integration as it's now bound with VoiceAlerts
      const isNotFcc499 = integration.integration_type !== "fcc 499";
      return matchesSearchTerm && matchesCategory && matchesVisibility && isNotFcc499;
    });

    const availableIntegrations = filteredIntegrations.map((integration) => ({
      key: integration.integration_type,
      imgSrc: `../../assets/images/integrations/${integration.img}`,
      alt: `${integration.integration_title} Image`,
      name: `${integration.integration_title} Integration`,
      settingsKey: integration.integration_type,
      status: integration.status,
      id: integration.id,
      active: integration.active,
      category: integration.category,
      visibility: integration.visibility,
      description: integration.integration_info || "No description available",
    }));

    const activeIntegrations = availableIntegrations.filter(
      (integration) => integration.status === "Yes"
    );

    const showNoIntegrationAlert = activeIntegrations.length === 0;

    const connectionStatus = getcallbackData[0]?.connection;

    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* <div
                className="nk-block-head nk-block-head-sm"
                style={{ padding: "0px" }}
              >
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      {" "}
                      <em className="icon ni ni-exchange"></em> Integrations
                    </h3>
                    <div className="nk-block-des text-soft">
                      <p> &nbsp;</p>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle
                        name="Integrations"
                        icon="icon ni ni-exchange"
                      />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentAgent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <button
                              type="button"
                              onClick={() => this.setRequestIntegration()}
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-exchange"></em>
                              &nbsp;Request For Integration
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-4">
                  <div className="form-group position-relative">
                    <form autoComplete="off" role="presentation">
                      <input type="text" style={{ display: "none" }} autoComplete="new-password" />
                      <div className="form-group position-relative">
                        <input
                          type="text"
                          className="form-control with-icon"
                          placeholder="Search Integration Apps"
                          onChange={this.handleSearchChange}
                          autoComplete="off"
                          autoCorrect="off"
                          autoCapitalize="off"
                          spellCheck="false"
                        />
                        <em className="icon ni ni-search inside-icon"></em>
                      </div>
                    </form>

                    <em className="icon ni ni-search inside-icon"></em>
                  </div>
                </div>

                <div
                  className="col-md-4"
                  style={{ position: "relative" }}
                  ref={this.dropdownRefVisibility}
                >
                  <div className="form-group position-relative">
                    <select
                      className="form-control with-icon-select select-no-default-arrow"
                      onChange={(e) =>
                        this.setState({ selectedVisibility: e.target.value })
                      }
                      onClick={this.toggleDropdownVisibility}
                    >
                      <option value="all">All</option>
                      <option value="public">Public</option>
                      <option value="private">Private</option>
                    </select>
                    <em className="icon ni ni-eye select-icon"></em>
                    <em
                      className={`icon ni ${
                        this.state.isDropdownOpen
                          ? "ni-upword-alt-fill"
                          : "ni-downward-alt-fill"
                      } select-arrow-icon`}
                    ></em>
                  </div>
                </div>

                <div
                  className="col-md-4"
                  style={{ position: "relative" }}
                  ref={this.dropdownRef}
                >
                  <div className="form-group position-relative">
                    <select
                      className="form-control with-icon-select select-no-default-arrow"
                      onChange={this.handleFilterChange}
                      onClick={this.toggleDropdown}
                    >
                      <option value="all">All</option>
                      {this.state.availableCategories.map((category, index) => (
                        <option key={index} value={category}>
                          {category}
                        </option>
                      ))}
                    </select>
                    <em className="icon ni ni-filter select-icon"></em>
                    <em
                      className={`icon ni ${
                        this.state.isDropdownOpen
                          ? "ni-upword-alt-fill"
                          : "ni-downward-alt-fill"
                      } select-arrow-icon`}
                    ></em>
                  </div>
                </div>
              </div>

              {this.state.errorQuickBooks !== "" ? (
                <div className="example-alert mt-2 mb-4">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{this.state.errorQuickBooks}</p>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.state.successQuickBooks !== "" ? (
                <div className="example-alert mt-2 mb-4">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{this.state.successQuickBooks}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="row" style={{ alignItems: "stretch" }}>
                {showNoIntegrationAlert && dataFetched ? (
                  <div className="alert alert-pro alert-warning col-md-12">
                    <div className="alert-text">
                      <h6>No Integration Available</h6>
                      <p>
                        Sorry, there are currently no integrations available.
                      </p>
                    </div>
                  </div>
                ) : (
                  <>
                    {activeIntegrations.map((integration) => (
                      <div className="col-12 col-sm-6 col-xl-4 col-xxl-3 mb-4" key={integration.key} style={{ display: "flex" }}>
                        <div
                          className="card card-bordered"
                          style={{ alignItems: "center", width: "100%", display: "flex", flexDirection: "column" }}
                        >
                          <img
                            src={integration.imgSrc}
                            className="card-img-top img_settings"
                            alt={integration.alt}
                          />
                          <div className="card-inner" style={{ width: "100%", flex: 1, display: "flex", flexDirection: "column" }}>
                            <div className="d-flex justify-content-between align-items-center">
                              <h6>{integration.name}</h6>
                              <Tooltip title="Integration Info" placement="top">
                                <a
                                  style={{
                                    cursor: "pointer",
                                    color: "#007bff",
                                    fontSize: "18px",
                                  }}
                                  onClick={() =>
                                    this.openIntegrationInfo(integration)
                                  }
                                >
                                  <em className="icon ni ni-info"></em>
                                </a>
                              </Tooltip>
                            </div>

                            <p
                              style={{
                                fontSize: "0.85rem",
                                color: "#6c757d",
                                marginBottom: "10px",
                              }}
                            >
                              {integration.category}
                              <span
                                style={{
                                  marginLeft: "8px",
                                  fontSize: "11px",
                                  fontWeight: "500",
                                  padding: "2px 8px",
                                  borderRadius: "12px",
                                  backgroundColor:
                                    integration.visibility === "public"
                                      ? "#e3f6e8"
                                      : "#fff2e6",
                                  color:
                                    integration.visibility === "public"
                                      ? "#1e8e3e"
                                      : "#d46b08",
                                  textTransform: "capitalize",
                                  display: "inline-block",
                                }}
                              >
                                {integration.visibility}
                              </span>
                            </p>
                            <div style={{ marginTop: "auto" }}>
                            {integration.key === "quickbooks" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    connectionStatus === "connected"
                                      ? ""
                                      : "btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (connectionStatus !== "connected") {
                                      this.getQuickBookAuth();
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      connectionStatus === "connected"
                                        ? "#2CA01C"
                                        : "",
                                    borderColor:
                                      connectionStatus === "connected"
                                        ? "#2CA01C"
                                        : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      connectionStatus === "connected"
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {connectionStatus === "connected"
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {connectionStatus === "connected" && (
                                  <Tooltip
                                    title="Revoke Connection"
                                    placement="top"
                                  >
                                    <a
                                      className="btn btn-danger"
                                      onClick={this.handleQuickBookIntegration}
                                      style={{
                                        cursor: "pointer",
                                        color: "white",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <em className="icon ni ni-cross"></em>
                                    </a>
                                  </Tooltip>
                                )}
                              </div>
                            ) : integration.key === "stripe" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1 ? "" : "btn-primary"
                                  } stripe-card-status ${this.stripeCardLabel().cls}`}
                                  onClick={this.openStripeModal}
                                  style={{ cursor: "pointer" }}
                                  title={integration.active === 1 ? "Open Stripe settings" : "Connect Stripe"}
                                >
                                  <em
                                    className={`icon ni ${
                                      integration.active === 1 ? "ni-check" : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.stripeCardLabel().text}
                                </a>
                                {integration.active === 1 && (
                                  <Tooltip title="Revoke Connection" placement="top">
                                    <a
                                      className="btn btn-danger"
                                      onClick={this.disconnectStripeFromCard}
                                      style={{ cursor: "pointer", color: "white", flexShrink: 0 }}
                                    >
                                      <em className="icon ni ni-cross"></em>
                                    </a>
                                  </Tooltip>
                                )}
                              </div>
                            ) : integration.key === "voicealerts" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? ""
                                      : "btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.handleVoiceAlertsIntegration(
                                        integration.id
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.handleVoiceAlertsDisconnect(
                                            integration.id
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                    <Tooltip title="Edit Settings" placement="top">
                                      <a
                                        className="btn btn-light"
                                        onClick={() =>
                                          this.openVoiceAlertsEditModal(
                                            integration.settingsKey,
                                            integration.id
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "#007bff",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-edit"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : integration.key === "metabase" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? "btn-large"
                                      : "btn-large btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.manageMetabaseConnection(
                                        integration.id
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button_meta
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button_meta
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.handleMetabaseIntegration(
                                            integration.id
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                    <Tooltip title="Edit Info" placement="top">
                                      <a
                                        className="btn btn-light"
                                        onClick={() =>
                                          this.integration_settings(
                                            integration.settingsKey
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "#007bff",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-edit"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : integration.key === "subpoena" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? ""
                                      : "btn-large btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.manageSubpoenaConnection(
                                        integration.id,
                                        "enable"
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button_meta
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button_meta
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.manageSubpoenaConnection(
                                            integration.id,
                                            "revoke"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : integration.key === "zapier" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? ""
                                      : "btn-large btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.manageZapierConnection(
                                        integration.id,
                                        "enable"
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button_meta
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button_meta
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.manageZapierConnection(
                                            integration.id,
                                            "revoke"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : integration.key === "convoso" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? ""
                                      : "btn-large btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.managePrivateConnection(
                                        integration.id,
                                        "enable"
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button_meta
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button_meta
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.managePrivateConnection(
                                            integration.id,
                                            "revoke"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : integration.key === "chatgpt" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? ""
                                      : "btn-large btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.manageChatGptConnection(
                                        integration.id,
                                        "enable"
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button_meta
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button_meta
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.manageChatGptConnection(
                                            integration.id,
                                            "revoke"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                    <Tooltip title="Edit Info" placement="top">
                                      <a
                                        className="btn btn-light"
                                        onClick={() =>
                                          this.integration_settings(
                                            integration.settingsKey
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "#007bff",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-edit"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : integration.key === "conversational" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? ""
                                      : "btn-large btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.manageConversationalConnection(
                                        integration.id,
                                        "enable"
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button_meta
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button_meta
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.manageConversationalConnection(
                                            integration.id,
                                            "revoke"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : integration.key === "twilio" ? (
                              <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                                <a
                                  className={`btn ${
                                    integration.active === 1
                                      ? ""
                                      : "btn-large btn-primary"
                                  }`}
                                  onClick={() => {
                                    if (integration.active === 0) {
                                      this.manageTwilioConnection(
                                        integration.id,
                                        "enable"
                                      );
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#ffffff",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    whiteSpace: "nowrap",
                                    backgroundColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                    borderColor:
                                      integration.active === 1 ? "#2CA01C" : "",
                                  }}
                                >
                                  <em
                                    className={`icon ni ${
                                      this.state.loading_button_meta
                                        ? ""
                                        : integration.active === 1
                                        ? "ni-check"
                                        : "ni-plus"
                                    }`}
                                  ></em>{" "}
                                  {this.state.loading_button_meta
                                    ? "Connecting..."
                                    : integration.active === 1
                                    ? "Connected"
                                    : "Connect"}
                                </a>
                                {integration.active === 1 && (
                                  <>
                                    <Tooltip
                                      title="Revoke Connection"
                                      placement="top"
                                    >
                                      <a
                                        className="btn btn-danger"
                                        onClick={() =>
                                          this.manageTwilioConnection(
                                            integration.id,
                                            "revoke"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                      </a>
                                    </Tooltip>
                                  </>
                                )}
                              </div>
                            ) : (
                              <a
                                className="btn btn-primary btn-block"
                                onClick={() =>
                                  this.integration_settings(
                                    integration.settingsKey
                                  )
                                }
                                style={{ cursor: "pointer", color: "#ffffff" }}
                              >
                                <em className="icon ni ni-plus"></em> Connect
                              </a>
                            )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {/* SIPNav Static Integration Card */}
                <div className="col-12 col-sm-6 col-xl-4 col-xxl-3 mb-4" style={{ display: "flex" }}>
                  <div className="card card-bordered" style={{ alignItems: "center", width: "100%", display: "flex", flexDirection: "column" }}>
                    <img
                      src="/assets/images/integrations/sipnav.png"
                      className="card-img-top img_settings"
                      alt="SIPNav Integration"
                    />
                    <div className="card-inner" style={{ width: "100%", flex: 1, display: "flex", flexDirection: "column" }}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6 className="mb-0">SIPNav Integration</h6>
                      </div>
                      <p style={{ fontSize: "0.82rem", color: "#6c757d", marginBottom: 8 }}>
                        SIP Trunking
                        <span
                          style={{
                            marginLeft: 8,
                            fontSize: 11,
                            fontWeight: 500,
                            padding: "2px 8px",
                            borderRadius: 12,
                            backgroundColor: "#fff2e6",
                            color: "#d46b08",
                            display: "inline-block",
                          }}
                        >
                          Private
                        </span>
                      </p>
                      <div style={{ marginTop: "auto" }}>
                      {this.state.sipnav_connected ? (
                        <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "6px" }}>
                          <a
                            className="btn"
                            style={{
                              cursor: "default",
                              color: "#fff",
                              backgroundColor: "#2CA01C",
                              borderColor: "#2CA01C",
                              flex: "1 1 auto",
                              minWidth: 0,
                              whiteSpace: "nowrap",
                            }}
                          >
                            <em className="icon ni ni-check"></em> Connected
                          </a>
                          <Tooltip title="Revoke Connection" placement="top">
                            <a
                              className="btn btn-danger"
                              onClick={() => !this.state.sipnav_revoking && this.revokeSipnav()}
                              style={{ cursor: this.state.sipnav_revoking ? "not-allowed" : "pointer", color: "white", flexShrink: 0, opacity: this.state.sipnav_revoking ? 0.7 : 1 }}
                            >
                              {this.state.sipnav_revoking
                                ? <em className="icon ni ni-loader"></em>
                                : <em className="icon ni ni-cross"></em>}
                            </a>
                          </Tooltip>
                        </div>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary btn-block"
                          onClick={() => this.openSipnavModal()}
                        >
                          Enable
                        </button>
                      )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-md-3">
                  <div
                    className="card card-bordered"
                    style={{ alignItems: "center" }}
                  >
                    <img
                      src="../../assets/images/integrations/quickbooks.png"
                      className="card-img-top img_settings"
                      alt="Static Integration Image"
                    />
                    <div className="card-inner" style={{ width: "100%" }}>
                      <h6>Quick Books</h6>
                      <div className="d-flex justify-content-between align-items-center">
                        <a
                          className={`btn ${
                            connectionStatus === "connected"
                              ? "btn-success"
                              : "btn-primary"
                          } btn-block`}
                          onClick={() => {
                            if (connectionStatus !== "connected") {
                              this.getQuickBookAuth();
                            }
                          }}
                          style={{ cursor: "pointer", color: "#ffffff" }}
                        >
                          <em className="icon ni ni-plus"></em>{" "}
                          {connectionStatus === "connected"
                            ? "Connected"
                            : "Connect"}
                        </a>
                        {connectionStatus === "connected" && (
                          <Tooltip title="Remove Connection" placement="top">
                            <a
                              className="btn btn-danger ml-2"
                              onClick={this.handleQuickBookIntegration}
                              style={{ cursor: "pointer", color: "white" }}
                            >
                              <em className="icon ni ni-trash"></em>
                            </a>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              {/*<div className="row g-gs">
                <div className="col-md-3">
                  <div
                    className="card card-bordered"
                    style={{ alignItems: "center" }}
                  >
                    <img
                      src="../../assets/images/integrations/voice.png"
                      className="card-img-top img_settings"
                      alt=""
                    />
                    <div className="card-inner" style={{ width: "100%" }}>
                      <h6>Lynk Telecom Integration</h6>

                      <a
                        className="btn btn-primary btn-block"
                        onClick={() => this.integration_settings("voycetel")}
                        style={{ cursor: "pointer", color: "#ffffff" }}
                      >
                        <em className="icon ni ni-plus"></em> Connect
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div
                    className="card card-bordered"
                    style={{ alignItems: "center" }}
                  >
                    <img
                      src="../../assets/images/integrations/voice-adm.png"
                      className="card-img-top img_settings"
                      alt=""
                    />
                    <div className="card-inner" style={{ width: "100%" }}>
                      <h6>Lynk AI Integration</h6>

                      <a
                        className="btn btn-primary btn-block"
                        onClick={() => this.integration_settings("voyceadmins")}
                        style={{ cursor: "pointer", color: "#ffffff" }}
                      >
                        <em className="icon ni ni-plus"></em> Connect
                      </a>
                    </div>
                  </div>
                </div>
              </div>*/}
            </div>
          </div>
          <div className="modal fade" tabindex="-1" id="modalDefault">
            <div
              className="modal-dialog modal-dialog-top modal-lg"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    <em className="icon ni ni-exchange"></em> Exciting Announcement:
                    Integrations Coming Soon!
                  </h5>
                </div>
                <div className="modal-body">
                  <p>
                    We are thrilled to share some exciting news that will
                    elevate your experience with our platform to new heights.
                    Our team has been hard at work behind the scenes, and we're
                    on the verge of introducing a game-changing feature –
                    Integrations!
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/** START INTEGRATION SETTINGS MODAL **/}
          <div
            className="modal fade"
            tabindex="-1"
            id="modalIntegrationSettings"
          >
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    <em className="icon ni ni-exchange"></em>{" "}
                    {this.state.integration_type_title}
                  </h5>
                </div>
                <div className="modal-body">
                  {this.state.IntErrorMessage !== "" ? (
                    <div className="example-alert mt-2 mb-2">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.IntErrorMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.IntSuccessMessage !== "" ? (
                    <div className="example-alert mt-2 mb-2">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.IntSuccessMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.formLoader === true ? (
                    FormLoader()
                  ) : (
                    <>
                      <div className="form-group mt-2">
                        <MutextField
                          required
                          id="wholesale_title"
                          name="wholesale_title"
                          type="text"
                          label="API Title"
                          value={this.state.wholesale_title}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group mt-2">
                        <MutextField
                          required
                          id="wholesale_url"
                          name="wholesale_url"
                          type="text"
                          label="API URL"
                          value={this.state.wholesale_url}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group mt-1">
                        <MutextField
                          required
                          id="wholesale_key"
                          name="wholesale_key"
                          type="text"
                          label="API Key"
                          value={this.state.wholesale_key}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group mt-1">
                        <MutextField
                          required
                          id="wholesale_auth"
                          name="wholesale_auth"
                          type="text"
                          label="API AUTH"
                          value={this.state.wholesale_auth}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group mt-1">
                        <MutextField
                          id="wholesale_active"
                          name="wholesale_active"
                          select
                          label="Select Status"
                          value={this.state.wholesale_active}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        >
                          <option key="1" value="1">
                            Active
                          </option>
                          <option key="0" value="0">
                            Inactive
                          </option>
                        </MutextField>
                      </div>

                      <div className="d-flex justify-content-end">
                        {/* {this.state.loading_button === false ? (
                          <>
                            {this.state.wholesale_is_verified === 0 ? (
                              <>
                                {this.state.wholesale_data &&
                                this.state.wholesale_data.length > 0 ? (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      this.VerifyWholeSaleConfig();
                                    }}
                                    disabled={this.state.disabled}
                                    href="#"
                                    className="btn btn-lg btn-primary"
                                  >
                                    <em className="icon ni ni-done"></em> Verify
                                    Details
                                  </a>
                                ) : (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      this.submitWholeSaleConfig();
                                    }}
                                    disabled={this.state.disabled}
                                    href="#"
                                    className="btn btn-lg btn-primary"
                                  >
                                    <em className="icon ni ni-file-docs"></em>{" "}
                                    Submit
                                  </a>
                                )}
                              </>
                            ) : this.state.wholesale_is_verified === 1 ? (
                              <button
                                disabled
                                type="button"
                                className="btn btn-lg btn-primary"
                              >
                                <em className="icon ni ni-done"></em> Verified
                              </button>
                            ) : null}
                          </>
                        ) : null} */}
                        {this.state.loading_button === true ? (
                          <button
                            className="btn btn-primary btn-lg"
                            type="button"
                            disabled
                          >
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span> Loading... </span>
                          </button>
                        ) : (
                          <>
                            {this.state.wholesale_data &&
                            this.state.wholesale_data.length > 0 ? (
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.VerifyWholeSaleConfig();
                                }}
                                disabled={this.state.disabled}
                                href="#"
                                className="btn btn-lg btn-primary"
                              >
                                <em className="icon ni ni-done"></em> Verify
                                Details
                              </a>
                            ) : (
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.submitWholeSaleConfig();
                                }}
                                disabled={this.state.disabled}
                                href="#"
                                className="btn btn-lg btn-primary"
                              >
                                <em className="icon ni ni-file-docs"></em>{" "}
                                Submit
                              </a>
                            )}
                          </>
                        )}
                      </div>

                      {/* <div className="example-alert mt-3">
                        <div className="alert alert-light ">
                          These configuration settings will integrate the
                          Wholsesale portal to the system.
                        </div>
                      </div> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/** END INTEGRATION SETTINGS MODAL **/}
          {/* START DELETE MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalQuickBookIntegration"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideDel();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                    <h4 className="nk-modal-title">
                      Revoke QuickBooks Connection?
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        Are you sure you want to revoke the connection?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideDel();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-danger"
                        onClick={() => {
                          this.deleteQuickBookIntegration();
                        }}
                        disabled={
                          this.state.disabled || this.state.isProcessing
                        } // disable button when processing
                      >
                        {this.state.isProcessing ? (
                          <span>REVOKING...</span>
                        ) : (
                          <span>REVOKE</span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END DELETE MODAL  */}

          {/* START VOICE DELETE MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalVoiceAlertsIntegration"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideVoiceDel();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                    <h4 className="nk-modal-title">
                      Revoke VoiceAlerts Connection?
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        Are you sure you want to revoke the connection?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideVoiceDel();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-danger"
                        onClick={() => {
                          this.deleteVoiceAlertsIntegration();
                        }}
                        disabled={
                          this.state.disabled || this.state.isProcessing
                        } // disable button when processing
                      >
                        {this.state.isProcessing ? (
                          <span>REVOKING...</span>
                        ) : (
                          <span>REVOKE</span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICE DELETE MODAL  */}

          {/* START VOICEALERTS SETTINGS MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalVoiceAlertsSettingsIntegration"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideVoiceAlertsSettings();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-md">
                  <h5 className="title">VoiceAlerts Integration Settings</h5>
                  <hr />
                  {this.state.errorMessageVoiceAlerts !== "" ? (
                    <div
                      className="example-alert"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.errorMessageVoiceAlerts}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessageVoiceAlerts !== "" ? (
                    <div
                      className="example-alert"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessageVoiceAlerts}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  <div className="tab-content mt-0">
                    <div className="form-group">
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="enableFcc499Connect"
                          checked={this.state.enable_fcc_499 === 1}
                          onChange={(e) =>
                            this.setState({
                              enable_fcc_499: e.target.checked ? 1 : 0,
                              enable_on_registration: e.target.checked ? this.state.enable_on_registration : 0,
                            })
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="enableFcc499Connect"
                        >
                          Enable 499 Filer Verification
                        </label>
                      </div>
                    </div>

                    {this.state.enable_fcc_499 === 1 && (
                      <div className="form-group" style={{ marginLeft: "25px" }}>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enableOnRegistrationConnect"
                            checked={this.state.enable_on_registration === 1}
                            onChange={(e) =>
                              this.setState({
                                enable_on_registration: e.target.checked ? 1 : 0,
                              })
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="enableOnRegistrationConnect"
                          >
                            Enable on Client Registration
                          </label>
                        </div>
                      </div>
                    )}

                    <div className="form-group" style={{ marginTop: "20px" }}>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          this.modalHideVoiceAlertsSettings();
                        }}
                        disabled={this.state.loading_button_voicealerts}
                      >
                        Cancel
                      </button>
                      {"  "}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          this.voiceAlertsIntegration();
                        }}
                        disabled={this.state.loading_button_voicealerts}
                      >
                        {this.state.loading_button_voicealerts ? (
                          <span>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span> Connecting...</span>
                          </span>
                        ) : (
                          <span>Connect</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICEALERTS SETTINGS MODAL  */}

          {/* START Meta DELETE MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalMetabaseIntegration"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideMetaDel();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                    <h4 className="nk-modal-title">
                      Revoke Metabase Connection?
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        Are you sure you want to revoke the connection?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideMetaDel();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-danger"
                        onClick={() => {
                          this.deleteMetabaseIntegration();
                        }}
                        disabled={
                          this.state.disabled || this.state.isProcessing
                        } // disable button when processing
                      >
                        {this.state.isProcessing ? (
                          <span>REVOKING...</span>
                        ) : (
                          <span>REVOKE</span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END Meta DELETE MODAL  */}

          {/** START Meta INTEGRATION SETTINGS MODAL **/}
          <div
            className="modal fade"
            tabindex="-1"
            id="modalIntegrationSettingsMeta"
          >
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    <em className="icon ni ni-exchange"></em>{" "}
                    {this.state.integration_type_title}
                  </h5>
                </div>
                <div className="modal-body">
                  {this.state.IntErrorMessage !== "" ? (
                    <div className="example-alert mt-1 mb-4">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.IntErrorMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.IntSuccessMessage !== "" ? (
                    <div className="example-alert mt-1 mb-4">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.IntSuccessMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.formLoader === true ? (
                    FormLoader()
                  ) : (
                    <>
                      <div className="form-group mt-2">
                        <MutextField
                          required
                          id="wholesale_url"
                          name="wholesale_url"
                          type="text"
                          label="API URL"
                          value={this.state.wholesale_url}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      {/*<div className="form-group mt-1">
                        <MutextField
                          required
                          id="wholesale_key"
                          name="wholesale_key"
                          type="text"
                          label="API Key"
                          value={this.state.wholesale_key}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>*/}

                      <div className="d-flex justify-content-end">
                        {this.state.loading_button === true ? (
                          <button
                            className="btn btn-primary btn-lg"
                            type="button"
                            disabled
                          >
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span> Loading... </span>
                          </button>
                        ) : (
                          <>
                            <a
                              style={{ cursor: "pointer", color: "white" }}
                              onClick={() => {
                                this.SubmitMetadataConfig();
                              }}
                              disabled={this.state.disabled}
                              className="btn btn-lg btn-primary"
                            >
                              <em className="icon ni ni-file-docs"></em> Submit
                            </a>
                          </>
                        )}
                      </div>

                      {/* <div className="example-alert mt-3">
                        <div className="alert alert-light ">
                          These configuration settings will integrate the
                          Wholsesale portal to the system.
                        </div>
                      </div> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/** END Meta INTEGRATION SETTINGS MODAL **/}
          {/** START Meta INTEGRATION SETTINGS MODAL **/}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalIntegrationSettingsChatGpt"
          >
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    <em className="icon ni ni-exchange"></em>{" "}
                    {this.state.integration_type_title}
                  </h5>
                </div>

                <div className="modal-body">
                  {/* Errors */}
                  {this.state.IntErrorMessage && (
                    <div className="example-alert mt-1 mb-4">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.IntErrorMessage}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.IntSuccessMessage && (
                    <div className="example-alert mt-1 mb-4">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.IntSuccessMessage}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.formLoader ? (
                    FormLoader()
                  ) : (
                    <>
                      {/* API Key Field */}
                      <div
                        className="form-group mt-2"
                        style={{ position: "relative" }}
                      >
                        <MutextField
                          required
                          id="wholesale_key"
                          name="wholesale_key"
                          type={
                            this.state.passwordShownChatGpt
                              ? "text"
                              : "password"
                          }
                          label="API KEY"
                          value={this.state.wholesale_key}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: {
                              paddingRight: "40px", // ✅ gives space for the eye icon
                            },
                          }}
                        autoComplete="new-password"
                        />

                        <span
                          onClick={this.handleEyeClickChatGpt}
                          style={{
                            position: "absolute",
                            right: "12px", // distance from edge
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "#666",
                            paddingLeft: "8px", // ✅ adds spacing between text and icon
                            background: "white", // optional: avoid overlap
                          }}
                        >
                          <em
                            className={`icon ni ${
                              this.state.passwordShownChatGpt
                                ? "ni-eye-off"
                                : "ni-eye"
                            }`}
                          ></em>
                        </span>
                      </div>

                      {/* Verification Section */}
                      {this.state.askVerify && (
                        <div className="mt-3 p-3 border rounded bg-light">
                          <h6
                            style={{ marginBottom: "10px", fontWeight: "600" }}
                          >
                            Verify Your Password
                          </h6>
                          <p
                            style={{
                              fontSize: "13px",
                              color: "#555",
                              marginBottom: "12px",
                            }}
                          >
                            Please enter your login password to view the{" "}
                            <strong>API Key</strong>.
                          </p>

                          <div style={{ position: "relative" }}>
                            <input
                              type={
                                this.state.showVerifyPassword
                                  ? "text"
                                  : "password"
                              }
                              value={this.state.loginPassword}
                              onChange={this.handleVerifyPasswordChange}
                              placeholder="Enter password"
                              autoComplete="off"
                              className="form-control"
                              style={{ paddingRight: "40px" }}
                              onKeyPress={(e) => {
                                if (e.key === "Enter")
                                  this.verifyLoginPassword();
                              }}
                            />

                            {/* Eye icon toggle */}
                            <span
                              onClick={() =>
                                this.setState({
                                  showVerifyPassword:
                                    !this.state.showVerifyPassword,
                                })
                              }
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                fontSize: "18px",
                                color: "#666",
                              }}
                            >
                              <em
                                className={`icon ni ${
                                  this.state.showVerifyPassword
                                    ? "ni-eye-off"
                                    : "ni-eye"
                                }`}
                              ></em>
                            </span>
                          </div>

                          {this.state.loginPasswordError && (
                            <p
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginTop: "6px",
                              }}
                            >
                              {this.state.loginPasswordError}
                            </p>
                          )}

                          <div className="d-flex justify-content-end mt-3">
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm mr-2"
                              onClick={() =>
                                this.setState({ askVerify: false })
                              }
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={this.verifyLoginPassword}
                              disabled={this.state.verifyingPassword}
                            >
                              {this.state.verifyingPassword
                                ? "Verifying..."
                                : "Verify"}
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Submit Button */}
                      <div className="d-flex justify-content-end mt-3">
                        {this.state.loading_button ? (
                          <button
                            className="btn btn-primary btn-lg"
                            type="button"
                            disabled
                          >
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span> Loading... </span>
                          </button>
                        ) : (
                          <a
                            style={{ cursor: "pointer", color: "white" }}
                            onClick={() => this.SubmitChatGptdataConfig()}
                            disabled={this.state.disabled}
                            className="btn btn-lg btn-primary"
                          >
                            <em className="icon ni ni-send"></em> Submit
                          </a>
                        )}
                      </div>

                      {/* Info Section */}
                      <div className="example-alert mt-4">
                        <div className="alert alert-light">
                          <div
                            className="alert-text"
                            style={{ lineHeight: "1.6", fontSize: "14px" }}
                          >
                            <h6
                              style={{ marginBottom: "8px", fontWeight: "600" }}
                            >
                              About this Integration
                            </h6>
                            <p style={{ marginBottom: "6px" }}>
                              The <strong>ChatGPT Integration</strong> is only
                              used for <strong>prompt generation</strong> and
                              <strong> AI-based text suggestions</strong>.
                            </p>
                            <p style={{ margin: 0 }}>
                              Provide a valid <strong>OpenAI API Key</strong>{" "}
                              above to enable AI assistance where allowed.
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/** END Meta INTEGRATION SETTINGS MODAL **/}

          {/* New Client Modal Start */}
          <div
            className="modal fade"
            tabindex="-1"
            id="modalRequestIntegration"
          >
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    <em
                      className="icon ni ni-exchange"
                      style={{ marginRight: "15px" }}
                    ></em>{" "}
                    Request For Integration
                  </h5>
                </div>
                <div className="modal-body">
                  {this.state.formLoader === true ? (
                    FormLoader()
                  ) : (
                    <div className="row g-4">
                      {this.state.errorMessage !== "" ? (
                        <div className="col-md-12 mb-3">
                          <div
                            className="example-alert example-alert-revoke"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessage}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div className="col-md-12 mb-3">
                          <div
                            className="example-alert example-alert-revoke"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessage}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="form-control-group">
                            <MutextField
                              id="name"
                              name="name"
                              type="text"
                              label="Full Name"
                              value={this.state.name}
                              inputProps={{ maxLength: 64 }}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /[^a-zA-Z0-9 ]/gi,
                                  ""
                                );
                              }}
                              helperText="Full name of the recipient."
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            autoComplete="new-password"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="form-control-group">
                            <MutextField
                              id="email"
                              name="email"
                              type="text"
                              label="Email Address"
                              value={this.state.email}
                              helperText="Email address of the recipient."
                              inputProps={{ maxLength: 100 }}
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            autoComplete="new-password"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="form-control-group">
                            <MutextField
                              id="super_admin_email"
                              name="super_admin_email"
                              type="text"
                              label="To Email Address"
                              value={this.state.super_admin_email}
                              helperText="This is the email where your email will be sent."
                              inputProps={{ maxLength: 100, readOnly: true }}
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            autoComplete="new-password"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="form-control-group">
                            <div className="form-control-group">
                              <MutextField
                                required
                                id="integration_type"
                                name="integration_type"
                                select
                                label="Select Integration"
                                value={this.state.integration_type}
                                onChange={this.handleChange}
                                SelectProps={{
                                  native: true,
                                }}
                                helperText="Kindly choose an integration."
                                variant="outlined"
                                fullWidth
                              autoComplete="new-password"
                              >
                                <option key="select-none" value=""></option>
                                {(() => {
                                  // List of all possible options
                                  const allOptions = [
                                    "QuickBooks",
                                    "VoiceAlerts",
                                    "Metabase",
                                    "SalesForce",
                                    "Zapier",
                                    "Zendesk",
                                    "Subpoena",
                                    "BCID",
                                    "Paypal",
                                    "Stripe",
                                    "FCC 499"
                                  ];

                                  // Filter out integrations where status is 1 or the title is already present in the list
                                  const availableOptions = allOptions.filter(
                                    (option) => {
                                      const isOptionInList =
                                        this.state.integration_type_list.some(
                                          (integration) =>
                                            integration.title === option &&
                                            integration.status === "Yes"
                                        );
                                      return !isOptionInList;
                                    }
                                  );

                                  return availableOptions.map(
                                    (option, index) => (
                                      <option
                                        key={`integration-${index}`}
                                        value={option}
                                      >
                                        {option}
                                      </option>
                                    )
                                  );
                                })()}
                              </MutextField>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="form-control-group">
                            <TextareaAutosize
                              maxrows={4}
                              name="comment"
                              id="comment"
                              aria-label=""
                              placeholder="Add Comment *"
                              inputProps={{ maxLength: 500 }}
                              //maxLength={500}
                              value={this.state.comment}
                              helperText="Maximum 500 characters"
                              onChange={this.handleChange}
                              style={{
                                width: "100%",
                                height: "100px",
                                borderColor: "rgba(0, 0, 0, 0.125)",
                                borderRadius: "4px",
                                padding: "5px",
                              }}
                              variant="outlined"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 d-flex justify-content-end">
                        <button
                          type="button"
                          onClick={() => this.saveRequestIntegration()}
                          className="btn btn-primary"
                          disabled={this.state.disabled}
                        >
                          <span>Send Request</span>{" "}
                          <em className="icon ni ni-emails"></em>
                        </button>
                      </div>
                      <div className="col-md-12">
                        <div className="example-alert">
                          <div className="alert alert-light">
                            <ul className="list">
                              <li>
                                An email will be dispatched to the provided
                                email address.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* New Client Modal End */}
          {/* START VOICE DELETE MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalSubpoenaIntegration"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideSubpoena();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                    <h4 className="nk-modal-title">
                      {this.state.integration_action === "revoke"
                        ? "Revoke Subpoena Integration?"
                        : "Enable Subpoena Integration?"}
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageSubpoena !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageSubpoena}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageSubpoena !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageSubpoena}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        {this.state.integration_action === "revoke"
                          ? "Are you sure you want to revoke the Subpoena integration?"
                          : "Are you sure you want to enable the Subpoena integration?"}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideSubpoena();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.integration_action === "revoke" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.subpoenaIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_subpoena
                          } // disable button when processing
                        >
                          {this.state.is_processing_subpoena ? (
                            <span>REVOKING...</span>
                          ) : (
                            <span>REVOKE</span>
                          )}
                        </a>
                      ) : this.state.integration_action === "enable" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.subpoenaIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_subpoena
                          } // disable button when processing
                        >
                          {this.state.is_processing_subpoena ? (
                            <span>ENABLING...</span>
                          ) : (
                            <span>ENABLE</span>
                          )}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICE DELETE MODAL  */}
          {/* START VOICE DELETE MODAL  */}
          <div className="modal fade" tabIndex="-1" id="modalZapierIntegration">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideZapier();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em
                      className={`nk-modal-icon icon icon-circle icon-circle-xxl ${
                        this.state.integration_action === "revoke"
                          ? "ni ni-trash bg-success"
                          : "ni ni-check bg-success"
                      }`}
                    />

                    <h4 className="nk-modal-title">
                      {this.state.integration_action === "revoke"
                        ? "Revoke Zapier Integration?"
                        : "Enable Zapier Integration?"}
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageZapier !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageZapier}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageZapier !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageZapier}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        {this.state.integration_action === "revoke"
                          ? "Are you sure you want to revoke the Zapier integration?"
                          : "Are you sure you want to enable the Zapier integration?"}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideZapier();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.integration_action === "revoke" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.zapierIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_zapier
                          } // disable button when processing
                        >
                          {this.state.is_processing_zapier ? (
                            <span>REVOKING...</span>
                          ) : (
                            <span>REVOKE</span>
                          )}
                        </a>
                      ) : this.state.integration_action === "enable" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.zapierIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_zapier
                          } // disable button when processing
                        >
                          {this.state.is_processing_zapier ? (
                            <span>ENABLING...</span>
                          ) : (
                            <span>ENABLE</span>
                          )}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICE DELETE MODAL  */}
          {/* START PRIVATE MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalPrivateIntegration"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHidePrivate();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em
                      className={`nk-modal-icon icon icon-circle icon-circle-xxl ${
                        this.state.integration_action === "revoke"
                          ? "ni ni-trash bg-success"
                          : "ni ni-check bg-success"
                      }`}
                    />

                    <h4 className="nk-modal-title">
                      {this.state.integration_action === "revoke"
                        ? "Revoke Private Integration?"
                        : "Enable Private Integration?"}
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessagePrivate !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessagePrivate}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessagePrivate !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessagePrivate}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        {this.state.integration_action === "revoke"
                          ? "Are you sure you want to revoke the Private integration?"
                          : "Are you sure you want to enable the Private integration?"}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHidePrivate();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.integration_action === "revoke" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.privateIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_private
                          } // disable button when processing
                        >
                          {this.state.is_processing_private ? (
                            <span>REVOKING...</span>
                          ) : (
                            <span>REVOKE</span>
                          )}
                        </a>
                      ) : this.state.integration_action === "enable" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.privateIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_private
                          } // disable button when processing
                        >
                          {this.state.is_processing_private ? (
                            <span>ENABLING...</span>
                          ) : (
                            <span>ENABLE</span>
                          )}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICE DELETE MODAL  */}
          {/* START PRIVATE MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalChatgptIntegration"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideChatgpt();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em
                      className={`nk-modal-icon icon icon-circle icon-circle-xxl ${
                        this.state.integration_action === "revoke"
                          ? "ni ni-trash bg-success"
                          : "ni ni-check bg-success"
                      }`}
                    />

                    <h4 className="nk-modal-title">
                      {this.state.integration_action === "revoke"
                        ? "Revoke ChatGpt Integration?"
                        : "Enable ChatGpt Integration?"}
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageChatgpt !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageChatgpt}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageChatgpt !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageChatgpt}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        {this.state.integration_action === "revoke"
                          ? "Are you sure you want to revoke the ChatGpt integration?"
                          : "Are you sure you want to enable the ChatGpt integration?"}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideChatgpt();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.integration_action === "revoke" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.chatgptIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_chatgpt
                          } // disable button when processing
                        >
                          {this.state.is_processing_chatgpt ? (
                            <span>REVOKING...</span>
                          ) : (
                            <span>REVOKE</span>
                          )}
                        </a>
                      ) : this.state.integration_action === "enable" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.chatgptIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_chatgpt
                          } // disable button when processing
                        >
                          {this.state.is_processing_chatgpt ? (
                            <span>ENABLING...</span>
                          ) : (
                            <span>ENABLE</span>
                          )}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICE DELETE MODAL  */}
          {/* START PRIVATE MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalConversationalIntegration"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideConversational();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em
                      className={`nk-modal-icon icon icon-circle icon-circle-xxl ${
                        this.state.integration_action === "revoke"
                          ? "ni ni-trash bg-success"
                          : "ni ni-check bg-success"
                      }`}
                    />

                    <h4 className="nk-modal-title">
                      {this.state.integration_action === "revoke"
                        ? "Revoke Conversational AI Integration?"
                        : "Enable Conversational AI Integration?"}
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageConversational !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageConversational}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageConversational !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageConversational}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        {this.state.integration_action === "revoke"
                          ? "Are you sure you want to revoke the Conversational AI integration?"
                          : "Are you sure you want to enable the Conversational AI integration?"}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideConversational();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.integration_action === "revoke" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.chatgptConversational(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_conversational
                          } // disable button when processing
                        >
                          {this.state.is_processing_conversational ? (
                            <span>REVOKING...</span>
                          ) : (
                            <span>REVOKE</span>
                          )}
                        </a>
                      ) : this.state.integration_action === "enable" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.chatgptConversational(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_conversational
                          } // disable button when processing
                        >
                          {this.state.is_processing_conversational ? (
                            <span>ENABLING...</span>
                          ) : (
                            <span>ENABLE</span>
                          )}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* START PRIVATE MODAL  */}
          <div className="modal fade" tabIndex="-1" id="modalTwilioIntegration">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideTwilio();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em
                      className={`nk-modal-icon icon icon-circle icon-circle-xxl ${
                        this.state.integration_action === "revoke"
                          ? "ni ni-trash bg-success"
                          : "ni ni-check bg-success"
                      }`}
                    />

                    <h4 className="nk-modal-title">
                      {this.state.integration_action === "revoke"
                        ? "Revoke Twilio Integration?"
                        : "Enable Twilio Integration?"}
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageTwilio !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageTwilio}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageTwilio !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageTwilio}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        {this.state.integration_action === "revoke"
                          ? "Are you sure you want to revoke the Twilio integration?"
                          : "Are you sure you want to enable the Twilio integration?"}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideTwilio();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.integration_action === "revoke" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.manageTwilioIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_twilio
                          } // disable button when processing
                        >
                          {this.state.is_processing_twilio ? (
                            <span>REVOKING...</span>
                          ) : (
                            <span>REVOKE</span>
                          )}
                        </a>
                      ) : this.state.integration_action === "enable" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.manageTwilioIntegration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_twilio
                          } // disable button when processing
                        >
                          {this.state.is_processing_twilio ? (
                            <span>ENABLING...</span>
                          ) : (
                            <span>ENABLE</span>
                          )}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICE DELETE MODAL  */}
          {/* START FCC 499 MODAL  */}
          <div className="modal fade" tabIndex="-1" id="modalFcc499Integration">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideFcc499();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em
                      className={`nk-modal-icon icon icon-circle icon-circle-xxl ${
                        this.state.integration_action === "revoke"
                          ? "ni ni-trash bg-success"
                          : "ni ni-check bg-success"
                      }`}
                    />

                    <h4 className="nk-modal-title">
                      {this.state.integration_action === "revoke"
                        ? "Revoke FCC 499 Integration?"
                        : "Enable FCC 499 Integration?"}
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageFcc499 !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageFcc499}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageFcc499 !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageFcc499}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text">
                        {this.state.integration_action === "revoke"
                          ? "Are you sure you want to revoke the FCC 499 integration?"
                          : "Are you sure you want to enable the FCC 499 integration?"}
                      </div>
                      
                      {this.state.integration_action === "enable" && (
                        <div className="form-group" style={{ marginTop: "20px", textAlign: "left" }}>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="enableOnRegistration"
                              checked={this.state.enable_on_registration === 1}
                              onChange={(e) => {
                                this.setState({
                                  enable_on_registration: e.target.checked ? 1 : 0
                                });
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="enableOnRegistration"
                            >
                              Enable on Client Registration
                              <Tooltip
                                title="When enabled, the FCC 499 Filer ID field will appear on client registration forms"
                                placement="top"
                              >
                                <em
                                  className="icon ni ni-info"
                                  style={{
                                    marginLeft: "8px",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    color: "#6c757d"
                                  }}
                                ></em>
                              </Tooltip>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideFcc499();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      {this.state.integration_action === "revoke" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.fcc499Integration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_fcc499
                          }
                        >
                          {this.state.is_processing_fcc499 ? (
                            <span>REVOKING...</span>
                          ) : (
                            <span>REVOKE</span>
                          )}
                        </a>
                      ) : this.state.integration_action === "enable" ? (
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-success"
                          onClick={() => {
                            this.fcc499Integration(
                              this.state.integration_action
                            );
                          }}
                          disabled={
                            this.state.disabled ||
                            this.state.is_processing_fcc499
                          }
                        >
                          {this.state.is_processing_fcc499 ? (
                            <span>ENABLING...</span>
                          ) : (
                            <span>ENABLE</span>
                          )}
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END FCC 499 MODAL  */}

          {/* FCC 499 EDIT MODAL */}
          <div className="modal fade" tabIndex="-1" id="modalFcc499EditIntegration">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideFcc499Edit();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-edit bg-primary" />

                    <h4 className="nk-modal-title">
                      Edit FCC 499 Settings
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageFcc499Edit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageFcc499Edit}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageFcc499Edit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageFcc499Edit}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text" style={{ marginBottom: "20px" }}>
                        Configure FCC 499 integration settings
                      </div>
                      
                      <div className="form-group" style={{ marginTop: "20px", textAlign: "left" }}>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="isEnabledOnRegistration"
                            checked={this.state.is_enabled_on_registration === 1}
                            onChange={(e) => {
                              this.setState({
                                is_enabled_on_registration: e.target.checked ? 1 : 0
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="isEnabledOnRegistration"
                          >
                            Enable on Client Registration
                            <Tooltip
                              title="When enabled, the FCC 499 Filer ID field will appear on client registration forms"
                              placement="top"
                            >
                              <em
                                className="icon ni ni-info"
                                style={{
                                  marginLeft: "8px",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  color: "#6c757d"
                                }}
                              ></em>
                            </Tooltip>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-light"
                        onClick={() => {
                          this.modalHideFcc499Edit();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.saveFcc499Config();
                        }}
                        disabled={
                          this.state.disabled ||
                          this.state.loading_button_fcc499_edit
                        }
                      >
                        {this.state.loading_button_fcc499_edit ? (
                          <span>SAVING...</span>
                        ) : (
                          <span>SAVE</span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END FCC 499 EDIT MODAL */}

          {/* VOICEALERTS EDIT MODAL */}
          <div className="modal fade" tabIndex="-1" id="modalVoiceAlertsEditIntegration">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideVoiceAlertsEdit();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-edit bg-primary" />

                    <h4 className="nk-modal-title">
                      Edit VoiceAlerts Settings
                    </h4>

                    <div className="nk-modal-text">
                      {this.state.errorMessageVoiceAlertsEdit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageVoiceAlertsEdit}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageVoiceAlertsEdit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageVoiceAlertsEdit}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="caption-text" style={{ marginBottom: "20px" }}>
                        Configure VoiceAlerts integration settings
                      </div>
                      
                      <div className="form-group" style={{ marginTop: "20px", textAlign: "left" }}>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enableFcc499"
                            checked={this.state.enable_fcc_499 === 1}
                            onChange={(e) => {
                              this.setState({
                                enable_fcc_499: e.target.checked ? 1 : 0,
                                enable_on_registration: e.target.checked ? this.state.enable_on_registration : 0
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="enableFcc499"
                          >
                            Enable 499 Filer Verification
                            <Tooltip
                              title="When enabled, FCC 499 Filer ID verification will be available"
                              placement="top"
                            >
                              <em
                                className="icon ni ni-info"
                                style={{
                                  marginLeft: "8px",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  color: "#6c757d"
                                }}
                              ></em>
                            </Tooltip>
                          </label>
                        </div>
                        
                        {this.state.enable_fcc_499 === 1 && (
                          <div className="custom-control custom-checkbox" style={{ marginLeft: "25px", marginTop: "10px" }}>
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="enableOnRegistration"
                              checked={this.state.enable_on_registration === 1}
                              onChange={(e) => {
                                this.setState({
                                  enable_on_registration: e.target.checked ? 1 : 0
                                });
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="enableOnRegistration"
                            >
                              Enable on Client Registration
                              <Tooltip
                                title="When enabled, the FCC 499 Filer ID field will appear on client registration forms"
                                placement="top"
                              >
                                <em
                                  className="icon ni ni-info"
                                  style={{
                                    marginLeft: "8px",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    color: "#6c757d"
                                  }}
                                ></em>
                              </Tooltip>
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-light"
                        onClick={() => {
                          this.modalHideVoiceAlertsEdit();
                        }}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.saveVoiceAlertsConfig();
                        }}
                        disabled={
                          this.state.disabled ||
                          this.state.loading_button_voicealerts_edit
                        }
                      >
                        {this.state.loading_button_voicealerts_edit ? (
                          <span>SAVING...</span>
                        ) : (
                          <span>SAVE</span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END VOICEALERTS EDIT MODAL */}

          <div
            className={`modal fade ${this.state.showInfoModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ display: this.state.showInfoModal ? "block" : "none" }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                {/* Close button */}
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={this.closeIntegrationInfo}
                >
                  <em className="icon ni ni-cross"></em>
                </a>

                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    {/* Integration Image */}
                    <img
                      src={this.state.selectedIntegration?.imgSrc}
                      alt={this.state.selectedIntegration?.alt}
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "contain",
                        // marginBottom: "20px",
                      }}
                    />

                    {/* Title */}
                    <h4
                      className="nk-modal-title mb-3"
                      style={{ fontWeight: "600" }}
                    >
                      {this.state.selectedIntegration?.name}
                    </h4>

                    {/* Description */}
                    <div
                      className="nk-modal-text"
                      style={{
                        backgroundColor: "#f9f9f9",
                        borderRadius: "8px",
                        padding: "20px",
                        fontSize: "15px",
                        color: "#444",
                        lineHeight: "1.7",
                        maxWidth: "600px",
                        margin: "0 auto",
                        textAlign: "justify", // ✅ justify alignment
                        textJustify: "inter-word", // ✅ cleaner spacing between words
                      }}
                    >
                      <p style={{ marginBottom: 0 }}>
                        {this.state.selectedIntegration?.description}
                      </p>
                    </div>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary"
                        onClick={this.closeIntegrationInfo}
                      >
                        <em className="icon ni ni-cross mr-1"></em> Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ======= SIPNav Step 1 Modal – API Credentials ======= */}
          <div className="modal fade" tabIndex="-1" id="modalSipnavStep1">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md" role="document">
              <div className="modal-content">
                {/* Fixed Header */}
                <div className="modal-header" style={{ borderBottom: "1px solid #e5e9f2", padding: "14px 20px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div
                      style={{
                        width: 40, height: 40, borderRadius: 10, background: "#f0f3ff",
                        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                      }}
                    >
                      <em className="icon ni ni-call" style={{ color: "#6576ff", fontSize: 20 }}></em>
                    </div>
                    <div>
                      <div style={{ color: "#364a63", fontWeight: 600, fontSize: "1rem" }}>Enable SIPNav Integration</div>
                      <div style={{ color: "#8094ae", fontSize: "0.8rem" }}>Step 1 of 2 — API Credentials</div>
                    </div>
                  </div>
                  <a style={{ cursor: "pointer" }} className="close" onClick={() => window.$("#modalSipnavStep1").modal("hide")}>
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>
                <div className="modal-body modal-body-md p-3">

                  {this.state.sipnav_step1_error !== "" && (
                    <div className="alert alert-pro alert-danger mb-3">
                      <div className="alert-text">
                        <h6>Error</h6>
                        <p>{this.state.sipnav_step1_error}</p>
                      </div>
                    </div>
                  )}

                  {this.state.sipnav_step1_success !== "" && (
                    <div className="alert alert-pro alert-success mb-3">
                      <div className="alert-text">
                        <h6>Success</h6>
                        <p>{this.state.sipnav_step1_success}</p>
                      </div>
                    </div>
                  )}

                  {/* Info banner */}
                  <div
                    style={{
                      background: "#edf3ff",
                      border: "1px solid #c3d5ff",
                      borderRadius: 8,
                      padding: "10px 14px",
                      marginBottom: 18,
                      display: "flex",
                      gap: 10,
                      fontSize: "0.85rem",
                      color: "#3c5099",
                    }}
                  >
                    <em className="icon ni ni-info-fill" style={{ fontSize: 18, flexShrink: 0, marginTop: 1 }}></em>
                    <span>
                      SIPNav provides SIP trunk provisioning via API. Enter your credentials below to connect.
                    </span>
                  </div>

                  <div className="form-group mt-2">
                    <MutextField
                      id="sipnav_documentation_url"
                      name="sipnav_documentation_url"
                      type="text"
                      label="Documentation URL"
                      placeholder="https://snapi.example.com/api/documentation#/"
                      value={this.state.sipnav_documentation_url}
                      onChange={this.handleChange}
                      variant="outlined"
                      fullWidth
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="form-group mt-2">
                    <MutextField
                      required
                      id="sipnav_api_url"
                      name="sipnav_api_url"
                      type="text"
                      label="API URL "
                      placeholder="https://sip.example.com"
                      value={this.state.sipnav_api_url}
                      onChange={this.handleChange}
                      variant="outlined"
                      fullWidth
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group mt-2">
                        <MutextField
                          required
                          id="sipnav_username"
                          name="sipnav_username"
                          type="text"
                          label="Username"
                          value={this.state.sipnav_username}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group mt-2" style={{ position: "relative" }}>
                        <MutextField
                          required
                          id="sipnav_password"
                          name="sipnav_password"
                          type={this.state.sipnav_show_password ? "text" : "password"}
                          label="Password"
                          value={this.state.sipnav_password}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          InputProps={{
                            style: { paddingRight: "40px" },
                          }}
                        />
                        <span
                          onClick={() =>
                            this.setState({ sipnav_show_password: !this.state.sipnav_show_password })
                          }
                          style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "#666",
                            background: "white",
                          }}
                        >
                          <em
                            className={`icon ni ${
                              this.state.sipnav_show_password ? "ni-eye-off" : "ni-eye"
                            }`}
                          ></em>
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
                {/* Fixed Footer */}
                <div className="modal-footer" style={{ borderTop: "1px solid #e5e9f2", padding: "12px 20px", gap: 10, justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => window.$("#modalSipnavStep1").modal("hide")}
                      disabled={this.state.sipnav_loading}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.submitSipnavCredentials()}
                      disabled={this.state.sipnav_loading}
                    >
                      {this.state.sipnav_loading ? (
                        <span>
                          <em className="icon ni ni-loader mr-1"></em>
                          Saving...
                        </span>
                      ) : (
                        <span>
                          <em className="icon ni ni-check mr-1"></em> 
                          Save
                        </span>
                      )}
                    </button>
                </div>
              </div>
            </div>
          </div>
          {/* ======= END SIPNav Step 1 Modal ======= */}

          {/* ======= SIPNav Step 2 Modal – SIP Settings ======= */}
          <div className="modal fade" tabIndex="-1" id="modalSipnavStep2">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
              <div className="modal-content">
                {/* Fixed Header */}
                <div className="modal-header" style={{ borderBottom: "1px solid #e5e9f2", padding: "14px 20px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 10,
                        background: "#f0f3ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <em className="icon ni ni-call" style={{ color: "#6576ff", fontSize: 20 }}></em>
                    </div>
                    <div>
                      <div style={{ color: "#364a63", fontWeight: 600, fontSize: "1rem" }}>
                        SIPNav Integration Settings
                      </div>
                      <div style={{ color: "#8094ae", fontSize: "0.8rem" }}>
                        Step 2 of 2 — SIP Configuration
                      </div>
                    </div>
                  </div>
                  <a style={{ cursor: "pointer" }} className="close" onClick={() => window.$("#modalSipnavStep2").modal("hide")}>
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>
                <div className="modal-body modal-body-md p-3" ref={this.sipnavStep2BodyRef}>

                  {this.state.sipnav_step2_error !== "" && (
                    <div className="alert alert-pro alert-danger mb-3">
                      <div className="alert-text">
                        <h6>Error</h6>
                        <p>{this.state.sipnav_step2_error}</p>
                      </div>
                    </div>
                  )}

                  {this.state.sipnav_step2_success !== "" && (
                    <div className="alert alert-pro alert-success mb-3">
                      <div className="alert-text">
                        <h6>Success</h6>
                        <p>{this.state.sipnav_step2_success}</p>
                      </div>
                    </div>
                  )}

                  {/* Step 1 Credentials Summary */}
                  <div
                    style={{
                      background: "#f8f9ff",
                      border: "1px solid #e5e9f2",
                      borderRadius: 8,
                      padding: "12px 16px",
                      marginBottom: 18,
                    }}
                  >
                    <div style={{ color: "#8094ae", fontWeight: 700, fontSize: "0.7rem", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>
                      Connection Details
                    </div>
                    <div style={{ fontSize: "0.85rem", lineHeight: 1.9 }}>
                      <div>
                        <span style={{ color: "#8094ae" }}>API URL: </span>
                        <span style={{ color: "#364a63", fontWeight: 500 }}>{this.state.sipnav_api_url_saved}</span>
                      </div>
                      <div>
                        <span style={{ color: "#8094ae" }}>Username: </span>
                        <span style={{ color: "#364a63", fontWeight: 500 }}>{this.state.sipnav_username_saved}</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ color: "#8094ae" }}>Password: </span>
                        <span style={{ color: "#364a63", letterSpacing: "0.15em" }}>••••••••••</span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          style={{ padding: "1px 10px", fontSize: "0.78rem" }}
                          onClick={() => this.openSipnavStep1ForEdit()}
                        >
                          Change
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Core Settings Header */}
                  <div style={{ 
                    marginTop: 24, 
                    marginBottom: 16, 
                    paddingBottom: 8, 
                    borderBottom: "1px solid #e5e9f2" 
                  }}>
                    <div style={{ color: "#364a63", fontWeight: 600, fontSize: "0.9rem" }}>
                      Core Settings
                    </div>
                  </div>

                  {/* Basic Settings */}
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group mt-2">
                        <MutextField
                          id="sipnav_cps_limit"
                          name="sipnav_cps_limit"
                          type="number"
                          label="CPS Limit"
                          placeholder="e.g. 10"
                          value={this.state.sipnav_cps_limit}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          helperText="Maximum 50 calls can be initiated per second."
                          inputProps={{ min: 0, max: 50 }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group mt-2">
                        <MutextField
                          id="sipnav_session_limit"
                          name="sipnav_session_limit"
                          type="number"
                          label="Session Limit"
                          placeholder="e.g. 100"
                          value={this.state.sipnav_session_limit}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          helperText="Maximum 500 active call sessions allowed."
                          inputProps={{ min: 0, max: 500 }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group mt-2">
                        <MutextField
                          id="sipnav_no_call_progress"
                          name="sipnav_no_call_progress"
                          type="number"
                          label="No Call Progress (sec)"
                          placeholder="e.g. 12"
                          value={this.state.sipnav_no_call_progress}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          inputProps={{ min: 0, max: 60 }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group mt-2">
                        <MutextField
                          id="sipnav_ring_time"
                          name="sipnav_ring_time"
                          type="number"
                          label="Ring Time (sec)"
                          placeholder="e.g. 30"
                          value={this.state.sipnav_ring_time}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          inputProps={{ min: 0, max: 99 }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Advanced Settings Header */}
                  <div style={{ 
                    marginTop: 24, 
                    marginBottom: 16, 
                    paddingBottom: 8, 
                    borderBottom: "1px solid #e5e9f2" 
                  }}>
                    <div style={{ color: "#364a63", fontWeight: 600, fontSize: "0.9rem" }}>
                      Advanced Settings
                    </div>
                  </div>

                  {/* Enforce CID Block */}
                  <div className="row">
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <MutextField
                          id="sipnav_capacity_group"
                          name="sipnav_capacity_group"
                          type="number"
                          label="Capacity Group"
                          placeholder="e.g. 1"
                          value={this.state.sipnav_capacity_group}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          inputProps={{ min: 0, max: 999 }}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <MutextField
                          id="sipnav_cid_block_min_asr"
                          name="sipnav_cid_block_min_asr"
                          type="number"
                          label="CID Block Min ASR"
                          placeholder="e.g. 10"
                          value={this.state.sipnav_cid_block_min_asr}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          inputProps={{ min: 0 }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* CID Block Settings - always visible */}
                  <div className="row">
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <MutextField
                          id="sipnav_cid_block_min_acd"
                          name="sipnav_cid_block_min_acd"
                          type="number"
                          label="CID Block Min ACD"
                          placeholder="e.g. 15"
                          value={this.state.sipnav_cid_block_min_acd}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          inputProps={{ min: 0, max: 999 }}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <MutextField
                          id="sipnav_cid_block_max_sdp"
                          name="sipnav_cid_block_max_sdp"
                          type="number"
                          label="CID Block Max SDP"
                          placeholder="e.g. 30"
                          value={this.state.sipnav_cid_block_max_sdp}
                          onChange={this.handleNumberChange}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                          inputProps={{ min: 0, max: 999  }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Toggle Settings Row 1 */}
                  <div className="row">
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_international_calls"
                              checked={this.state.sipnav_international_calls}
                              onChange={() => this.handleSipnavToggle('sipnav_international_calls')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_international_calls"></label>
                          </div>
                          <label htmlFor="sipnav_international_calls" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                            International Calls
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_disable_rate_deck"
                              checked={this.state.sipnav_disable_rate_deck}
                              onChange={() => this.handleSipnavToggle('sipnav_disable_rate_deck')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_disable_rate_deck"></label>
                          </div>
                          <label htmlFor="sipnav_disable_rate_deck" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                            Disable Rate Deck Validation
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Capacity Group */}
                  <div className="row">
                    <div className="col-6" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="sipnav_enforce_cid_block"
                          checked={this.state.sipnav_enforce_cid_block}
                          onChange={() => this.handleSipnavToggle('sipnav_enforce_cid_block')}
                        />
                        <label className="custom-control-label" htmlFor="sipnav_enforce_cid_block"></label>
                      </div>
                      <label htmlFor="sipnav_enforce_cid_block" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                        Enforce CID Block
                      </label>
                    </div>
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_dnis_blacklist"
                              checked={this.state.sipnav_dnis_blacklist}
                              onChange={() => this.handleSipnavToggle('sipnav_dnis_blacklist')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_dnis_blacklist"></label>
                          </div>
                          <label htmlFor="sipnav_dnis_blacklist" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                            DNIS Blacklist
                          </label>
                        </div>
                      </div>
                    </div>
                    
                  </div>

                  {/* Toggle Settings Row 3 */}
                  <div className="row">
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_remove_cid_name"
                              checked={this.state.sipnav_remove_cid_name}
                              onChange={() => this.handleSipnavToggle('sipnav_remove_cid_name')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_remove_cid_name"></label>
                          </div>
                          <label htmlFor="sipnav_remove_cid_name" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                            Remove CID Name
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_block_dnc"
                              checked={this.state.sipnav_block_dnc}
                              onChange={() => this.handleSipnavToggle('sipnav_block_dnc')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_block_dnc"></label>
                          </div>
                          <label htmlFor="sipnav_block_dnc" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                            Block DNC
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Toggle Settings Row 2 */}
                  <div className="row">
                    <div className="col-6">
                      <div className="mt-2 mb-2">
                        <MutextField
                          id="sipnav_attestation_blocking"
                          name="sipnav_attestation_blocking"
                          select
                          label="Attestation Blocking"
                          value={this.state.sipnav_attestation_blocking}
                          onChange={this.handleChange}
                          SelectProps={{ native: true }}
                          variant="outlined"
                          fullWidth
                          autoComplete="new-password"
                        >
                          <option value="filtering_disabled">Filtering Disabled</option>
                          <option value="block_non_attested">Block Non-Attested</option>
                          <option value="block__attested">Block A-Attested</option>
                        </MutextField>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mt-2">
                        <MutextField
                          select
                          id="sipnav_block_matching_src_dst"
                          name="sipnav_block_matching_src_dst"
                          label="Block Matching Src/Dst"
                          value={this.state.sipnav_block_matching_src_dst}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                          SelectProps={{ native: true }}
                        >
                          <option value="disabled">OFF</option>
                          <option value="enabled">NPANXX</option>
                          <option value="log_only">Full Number</option>
                        </MutextField>
                      </div>
                    </div>
                  </div>

                  {/* Attestation Blocking Dropdown */}
                  <div className="mt-2 mb-2">
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="sipnav_block_wireless"
                          checked={this.state.sipnav_block_wireless}
                          onChange={() => this.handleSipnavToggle('sipnav_block_wireless')}
                        />
                        <label className="custom-control-label" htmlFor="sipnav_block_wireless"></label>
                      </div>
                      <label htmlFor="sipnav_block_wireless" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                        Block Wireless
                      </label>
                    </div>
                  </div>

                  {/* Disable Call Restrictions + ANI Blacklist side by side */}
                  <div className="row mt-3">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label style={{ color: "#364a63", fontWeight: 500, display: "block", marginBottom: 8 }}>
                          Disable Call Restrictions
                        </label>
                        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", border: "1px solid #e5e9f2", borderRadius: 6, padding: "10px 14px" }}>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_disable_call_restrictions_cid"
                              checked={this.state.sipnav_disable_call_restrictions_cid}
                              onChange={() => this.handleSipnavToggle('sipnav_disable_call_restrictions_cid')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_disable_call_restrictions_cid">CID</label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_disable_call_restrictions_destination"
                              checked={this.state.sipnav_disable_call_restrictions_destination}
                              onChange={() => this.handleSipnavToggle('sipnav_disable_call_restrictions_destination')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_disable_call_restrictions_destination">Destination</label>
                          </div>
                          {/* <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_disable_call_restrictions_ani"
                              checked={this.state.sipnav_disable_call_restrictions_ani}
                              onChange={() => this.handleSipnavToggle('sipnav_disable_call_restrictions_ani')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_disable_call_restrictions_ani">ANI</label>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label style={{ color: "#364a63", fontWeight: 500, display: "block", marginBottom: 8 }}>
                          ANI Blacklist
                        </label>
                        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", border: "1px solid #e5e9f2", borderRadius: 6, padding: "10px 14px" }}>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_ani_blacklist_global"
                              checked={this.state.sipnav_ani_blacklist_global}
                              onChange={() => this.handleSipnavToggle('sipnav_ani_blacklist_global')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_ani_blacklist_global">Global</label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_ani_blacklist_custom"
                              checked={this.state.sipnav_ani_blacklist_custom}
                              onChange={() => this.handleSipnavToggle('sipnav_ani_blacklist_custom')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_ani_blacklist_custom">Custom</label>
                          </div>
                          {/* <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sipnav_ani_blacklist_none"
                              checked={this.state.sipnav_ani_blacklist_none}
                              onChange={() => this.handleSipnavToggle('sipnav_ani_blacklist_none')}
                            />
                            <label className="custom-control-label" htmlFor="sipnav_ani_blacklist_none">None</label>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* SN Account IPs */}
                  <div className="form-group mt-3">
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 6 }}>
                      <div>
                        <div style={{ color: "#8094ae", fontWeight: 700, fontSize: "0.7rem", letterSpacing: "0.08em", textTransform: "uppercase" }}>
                          SN Account IPs
                        </div>
                        <small style={{ color: "#8094ae" }}>
                          Used for Origination/Termination trunks (shown to clients)
                        </small>
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        style={{ flexShrink: 0 }}
                        onClick={() => this.addSipnavIP('account')}
                      >
                        + Add IP
                      </button>
                    </div>
                    {this.state.sipnav_account_ips.map((ip, index) => (
                      <div key={index} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                        <MutextField
                          value={ip}
                          onChange={(e) => this.handleSipnavIPChange('account', index, e.target.value)}
                          variant="outlined"
                          placeholder="0.0.0.0"
                          fullWidth
                          autoComplete="new-password"
                        />
                        <button
                          type="button"
                          onClick={() => this.removeSipnavIP('account', index)}
                          style={{
                            minWidth: 36, height: 36, alignSelf: "center",
                            background: "#fff0f0", border: "1px solid #f5c6c6",
                            borderRadius: 6, color: "#e85347", cursor: "pointer",
                            fontSize: "1rem", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center"
                          }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>

                  {/* SN Carrier IPs */}
                  <div className="form-group mt-3">
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 6 }}>
                      <div>
                        <div style={{ color: "#8094ae", fontWeight: 700, fontSize: "0.7rem", letterSpacing: "0.08em", textTransform: "uppercase" }}>
                          SN Carrier IPs
                        </div>
                        <small style={{ color: "#8094ae" }}>
                          Carrier-side IPs (not shown to clients)
                        </small>
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        style={{ flexShrink: 0 }}
                        onClick={() => this.addSipnavIP('carrier')}
                      >
                        + Add IP
                      </button>
                    </div>
                    {this.state.sipnav_carrier_ips.map((ip, index) => (
                      <div key={index} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                        <MutextField
                          value={ip}
                          onChange={(e) => this.handleSipnavIPChange('carrier', index, e.target.value)}
                          variant="outlined"
                          placeholder="0.0.0.0"
                          fullWidth
                          autoComplete="new-password"
                        />
                        <button
                          type="button"
                          onClick={() => this.removeSipnavIP('carrier', index)}
                          style={{
                            minWidth: 36, height: 36, alignSelf: "center",
                            background: "#fff0f0", border: "1px solid #f5c6c6",
                            borderRadius: 6, color: "#e85347", cursor: "pointer",
                            fontSize: "1rem", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center"
                          }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>

                </div>
                {/* Fixed Footer */}
                <div className="modal-footer" style={{ borderTop: "1px solid #e5e9f2", padding: "12px 20px", gap: 10, justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => window.$("#modalSipnavStep2").modal("hide")}
                      disabled={this.state.sipnav_loading}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.submitSipnavSettings()}
                      disabled={this.state.sipnav_loading}
                    >
                      {this.state.sipnav_loading ? (
                        <span>
                          <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                          Saving...
                        </span>
                      ) : (
                        <span>
                          <em className="icon ni ni-check mr-1"></em> Save &amp; Finish
                        </span>
                      )}
                    </button>
                </div>
              </div>
            </div>
          </div>
          {/* ======= END SIPNav Step 2 Modal ======= */}

          <StripeModal
            ref={(r) => (this.stripeModalRef = r)}
            status={this.state.stripeStatus}
            accountno={auth.getAccount()}
            token={auth.getToken()}
            onStatusChange={this.onStripeStatusChange}
            toast={this.stripeToast}
          />
          <NotificationToast
            message={this.state.stripeToastMsg}
            type={this.state.stripeToastType}
            onDismiss={() => this.setState({ stripeToastMsg: "" })}
          />

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
    setLeftMenu: (menuItems) => dispatch(setLeftMenu(menuItems)),
    setStripeStatus: (status) => dispatch(setStripeStatus(status)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Integrations);

